function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    var selectedText = $(".custom_product_quantity")
      .find("option:selected")
      .text();
    var selectedValue = $(".custom_product_quantity").val();
    $(".custom_product_quantity").on("change", function () {
      selectedText = $(this).find("option:selected").text();
      selectedValue = $(this).val();
      $(".customqtyinput").val(selectedValue);
      $(".customqtyinput").attr("data-cart-quantity", selectedValue);
    });

    if (this.input) {
      this.input = this.querySelector("input");
      this.changeEvent = new Event("change", { bubbles: true });

      this.input.addEventListener("change", this.onInputChange.bind(this));
    }

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    if (this.input) {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        const buttonMinus = this.querySelector(
          ".quantity__button[name='minus']"
        );
        buttonMinus.classList.toggle("disabled", value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        buttonPlus.classList.toggle("disabled", value >= max);
      }
    }
  }
}

customElements.define("quantity-input", QuantityInput);

class QuantityInputCart extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}
customElements.define("quantity-input-cart", QuantityInputCart);

class QuantitySelectCart extends HTMLElement {
  constructor() {
    super();

    var selected_Text = $(".customproductquantity")
      .find("option:selected")
      .text();

    var selected_Value = $(".customproductquantity").val();
    $(".customproductquantity").on("change", function () {
      selected_Text = $(this).find("option:selected").text();
      selected_Value = $(this).val();
      $(".customqty_input").val(selected_Value);
      $(".customqty_input").attr("data-cart-quantity", selected_Value);
    });

    $(".showmorecartpill").click(function () {
      $(this)
        .parent(".cart_custom_product_variant_container")
        .find(".custom_select_varcont")
        .css({ display: "block" });
      $(this).hide();
    });

    $(".cartselected")
      .unbind()
      .on("click", function () {
        if (
          $(this)
            .parent(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .hasClass("show")
        ) {
          $(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .not(this)
            .removeClass("show");
          $(this)
            .parent(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .removeClass("show");
        } else {
          $(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .not(this)
            .removeClass("show");
          $(this)
            .parent(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .addClass("show");
        }
      });

    /**======cart drawer=========**/
    $(".cart_custom_variants_pills").click(function () {
      var thisto = $(this);
      var sel_var = $(this).attr("data-varimage");
      // console.log("cartdrawerselvar==" + sel_var);
      $(this)
        .parents(".custom_card_recommendation")
        .find(".custom_card_recommendation_media img")
        .attr("src", sel_var);
      $(this)
        .parents(".custom_card_recommendation")
        .find(".variants-pills")
        .removeClass("selected");
      $(this).addClass("selected");

      var selectedcolor = $(this).data("colorname");
      var selectedsize = $(this)
        .parents(".card_recommendation_container")
        .find(".sizeselectedvar.selected .selectedvar")
        .text();
      var varname = selectedcolor + "/" + selectedsize;
      //console.log("cartdrawervarname==" + varname);

      $(this)
        .parents(".custom_card_recommendation")
        .find(".comp_product_variants")
        .find("option")
        .each(function (index) {
          var varoption1 = $(this).data("option1");
          var varoption2 = $(this).data("option2");
          var varoption3 = $(this).data("option3");

          if (
            varname.indexOf(varoption1) != -1 &&
            varname.indexOf(varoption2) != -1 &&
            varname.indexOf(varoption3) != -1
          ) {
            var currid = $(this).attr("value");
            $(thisto)
              .parents(".custom_card_recommendation")
              .find(".preordertextcart")
              .hide();
            $(thisto)
              .parents(".custom_card_recommendation")
              .find(".preorder-input")
              .remove();
            $(thisto)
              .parents(".custom_card_recommendation")
              .find(".product-may-variants-all")
              .find(".product-variant-inner")
              .each(function () {
                if ($(this).data("varid") == currid) {
                  if (
                    $(this).data("preorder") == true &&
                    $(this).data("pravailable") == true
                  ) {
                    //console.log("currid=="+currid+"preorderid==="+$(this).data('varid'));
                    $(this)
                      .parents(".custom_card_recommendation")
                      .find(".preordertextcart")
                      .show();
                    $(this)
                      .parents(".custom_card_recommendation")
                      .find(".custom_complementary_addproduct").before(`<input
                      class="preorder-input"
                      type="hidden"
                      name="properties[Preorder]"
                      value="${$(this).data("preordertext")}"
                    >`);
                  }
                }
              });

            $(".cart_complemetary_product_id").val($(this).attr("value"));
          }
        });
    });

    $(".cartsizeoptionslist li").click(function () {
      var thisto = $(this);
      var selectedvalue = $(this).data("value");
      $(this)
        .parent(".cartsizeoptionslist")
        .parent(".sizeoptions")
        .parent(".cart_custom_drop_down_size")
        .find(".selected .selectedvar")
        .text(selectedvalue);
      $(
        ".cart_custom_drop_down_size .sizeoptions .cartsizeoptionslist"
      ).removeClass("show");

      var selectedcolor = $(this)
        .parents(".card_recommendation_container")
        .find(".cart_custom_variants_pills.selected")
        .data("colorname");
      var selectedsize = $(this).data("value");
      var varname = selectedcolor + "/" + selectedsize;
      //console.log("cartdrawerselectsize==" + varname);
      $(this)
        .parents(".custom_card_recommendation")
        .find(".comp_product_variants")
        .find("option")
        .each(function (index) {
          var varoption1 = $(this).data("option1");
          var varoption2 = $(this).data("option2");
          var varoption3 = $(this).data("option3");

          if (
            varname.indexOf(varoption1) != -1 &&
            varname.indexOf(varoption2) != -1 &&
            varname.indexOf(varoption3) != -1
          ) {
            var currid = $(this).attr("value");
            $(thisto)
              .parents(".custom_card_recommendation")
              .find(".preordertextcart")
              .hide();
            $(thisto)
              .parents(".custom_card_recommendation")
              .find(".preorder-input")
              .remove();
            $(thisto)
              .parents(".custom_card_recommendation")
              .find(".product-may-variants-all")
              .find(".product-variant-inner")
              .each(function () {
                if ($(this).data("varid") == currid) {
                  if (
                    $(this).data("preorder") == true &&
                    $(this).data("pravailable") == true
                  ) {
                    //console.log("currid=="+currid+"preorderid==="+$(this).data('varid'));
                    $(this)
                      .parents(".custom_card_recommendation")
                      .find(".preordertextcart")
                      .show();
                    $(this)
                      .parents(".custom_card_recommendation")
                      .find(".custom_complementary_addproduct").before(`<input
                      class="preorder-input"
                      type="hidden"
                      name="properties[Preorder]"
                      value="${$(this).data("preordertext")}"
                    >`);
                  }
                }
              });

            $(".cart_complemetary_product_id").val($(this).attr("value"));
          }
        });
    });

    $(document).bind("click", function (e) {
      var $clicked = $(e.target);
      if (!$clicked.parents().hasClass("cart_custom_drop_down_size"))
        $(
          ".cart_custom_drop_down_size .sizeoptions .cartsizeoptionslist"
        ).removeClass("show");
    });
    /**=======end cart drawer===========**/
  }
}
customElements.define("quantity-select-cart", QuantitySelectCart);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        $(".custom-megamenu").addClass("visible");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 400);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
      $(".custom-megamenu").addClass("visible");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
      $(".custom-megamenu").removeClass("visible");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    $(".custom-megamenu").removeClass("visible");

    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 100) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
      $(".custom-megamenu").addClass("visible");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".menu_drawer_heading").click(function (e) {
        e.preventDefault();

        let $this = $(this);

        if ($this.next().hasClass("show")) {
          $this.next().removeClass("show");
          $this.removeClass("hide-arrow");
          $this.next().slideUp(350);
          $this.find("svg").css({ transform: "rotate(0deg)" });
        } else {
          $this
            .parent()
            .parent()
            .find("li .menu_drawer_accordion")
            .removeClass("show");
          $this
            .parent()
            .parent()
            .find("li .menu_drawer_accordion")
            .slideUp(350);
          $this.next().toggleClass("show");
          $this.next().slideToggle(350);
          $this.find("svg").css({ transform: "rotate(-180deg)" });
        }
      });

      $(".header_mob_cross").on("click", this.onCloseButtonClick.bind(this));

      // $(".header_mob_cross").click(function () {
      //    // $(".header__icon--menu").attr("aria-expanded", "false");
      //    // $(".section-header").removeClass("menu-open");
      //    // $(".menu-drawer-container").removeClass("menu-opening");
      //    //  // $(".menu-drawer-container").removeAttr("open");
      //    //  $("body").removeClass("overflow-hidden-tablet");

      // });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("header-drawer", HeaderDrawer);

class HeaderMegaMenu extends MenuDrawer {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var megamenuaction = $(".header__menu-item").data("megamenuaction");
      //console.log("megamenuaction===" + megamenuaction);

      if (megamenuaction == "hover") {
        $(".header__menu-item").unbind();

        $(this).hover(
          function () {
            $(".custom-megamenu").removeClass("visible");
            $(this).parent().find(".custom-megamenu").addClass("visible");
            $(this).css({ "border-bottom": "2px solid #212121" });
          },
          function () {
            // $(".custom-megamenu").removeClass("visible");
            // $(this).parent().find(".custom-megamenu").removeClass("visible");
            // $(this).css({"border-bottom":"0px solid #212121"});
          }
        );

        $(this)
          .parent()
          .find(".custom-megamenu")
          .hover(
            function () {
              $(this).addClass("visible");
            },
            function () {
              $(this).removeClass("visible");
            }
          );

        // .mouseenter(function (){
        //   if ($(this).parent().find(".custom-megamenu").length){

        //     // if ($(this).parent().find(".custom-megamenu").hasClass("visible")) {
        //     //   $(".custom-megamenu").removeClass("visible");
        //     //   $(".header__menu-item").css({"border-bottom":"0px solid #212121"});
        //     //   $(this).parents('.list-menu').find(".header__menu-item").css({"border-bottom":"0px solid #212121"});
        //     // } else {
        //     //   $(".custom-megamenu").removeClass("visible");
        //     //   $(".header__menu-item").css({"border-bottom":"0px solid #212121"});
        //     //   $(this).parents('.list-menu').find(".header__menu-item").css({"border-bottom":"0px solid #212121"});
        //     //   $(this)
        //     //     .parent()
        //     //     .find(".custom-megamenu.visible")
        //     //     .removeClass("visible");
        //     //   $(this).parent().find(".custom-megamenu").addClass("visible");
        //     //   $(this).css({"border-bottom":"2px solid #212121"});
        //     // }
        //   }
        // });
        // .mouseleave(function (){
        //   if ($(this).parent().find(".custom-megamenu").length){
        //       $(".custom-megamenu").removeClass("visible");
        //       $(this).parent().find(".custom-megamenu").removeClass("visible");
        //       $(this).css({"border-bottom":"2px solid #212121"});
        //   }
        // });
      } else {
        $(".header__menu-item")
          .unbind()
          .click(function () {
            if ($(this).parent().find(".custom-megamenu").length) {
              if (
                $(this).parent().find(".custom-megamenu").hasClass("visible")
              ) {
                $(".custom-megamenu").removeClass("visible");
                $(".header__menu-item").css({
                  "border-bottom": "0px solid #212121",
                });
                $(this)
                  .parents(".list-menu")
                  .find(".header__menu-item")
                  .css({ "border-bottom": "0px solid #212121" });
              } else {
                $(".custom-megamenu").removeClass("visible");
                $(".header__menu-item").css({
                  "border-bottom": "0px solid #212121",
                });
                $(this)
                  .parents(".list-menu")
                  .find(".header__menu-item")
                  .css({ "border-bottom": "0px solid #212121" });
                $(this)
                  .parent()
                  .find(".custom-megamenu.visible")
                  .removeClass("visible");
                $(this).parent().find(".custom-megamenu").addClass("visible");
                $(this).css({ "border-bottom": "2px solid #212121" });
              }
            }
          });
      }

      $(".custom-megamenu").on("blur", function () {
        $(".custom-megamenu").removeClass("visible");
      });
      $(".announcement--bar-container").hover(function () {
        $(".custom-megamenu").removeClass("visible");
      });
      window.addEventListener(
        "resize",
        function (event) {
          $(".custom-megamenu").removeClass("visible");
        },
        true
      );
      document.addEventListener(
        "click",
        function (event) {
          // If user either clicks X button OR clicks outside the modal window, then close modal by calling closeModal()
          if (
            !event.target.closest(".custom-megamenu") &&
            !event.target.closest(".header__menu-item")
          ) {
            $(".custom-megamenu").removeClass("visible");
          }
        },
        false
      );

      $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
          $(".custom-megamenu").removeClass("visible");
          $(".header__menu-item").css({ "border-bottom": "0px solid #212121" });
        }
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-header-menu", HeaderMegaMenu);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if ($("product-modal[open]").length) {
        } else {
          if (
            event.pointerType === "mouse" &&
            !event.target.closest("deferred-media, product-model")
          ) {
            this.hide();
          }
        }
      });
    } else {
      this.addEventListener("click", (event) => {
        if ($("product-modal[open]").length) {
        } else {
          if (event.target === this) this.hide();
        }
      });
    }
    var this2 = this;
    $(document).keydown(function (e) {
      if (e.keyCode == 27) {
        this2.hide();
      }
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".productinbtn").click(function () {
        $(this).addClass("active");
        $(this)
          .parents(".product-popup-modal__content-info")
          .find(".inchtablecontainer")
          .addClass("active");

        $(this)
          .parents(".product-popup-modal__content-info")
          .find(".productcmbtn")
          .removeClass("active");
        $(this)
          .parents(".product-popup-modal__content-info")
          .find(".cmtablecontainer")
          .removeClass("active");
      });

      $(".productcmbtn").click(function () {
        $(this).addClass("active");
        $(this)
          .parents(".product-popup-modal__content-info")
          .find(".cmtablecontainer")
          .addClass("active");

        $(this)
          .parents(".product-popup-modal__content-info")
          .find(".productinbtn")
          .removeClass("active");
        $(this)
          .parents(".product-popup-modal__content-info")
          .find(".inchtablecontainer")
          .removeClass("active");
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    $("body").css({ overflow: "hidden" });
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    //removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    $("body").css({ overflow: "unset" });
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponentDesktop extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');

    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientHeight > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;

    this.slidesPerPage = Math.floor(
      (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    // if (
    //   this.isSlideVisible(this.sliderItemsToShow[0]) &&
    //   this.slider.scrollTop  === 0
    // ) {
    //   this.prevButton.setAttribute("disabled", "disabled");
    // } else {
    //   this.prevButton.removeAttribute("disabled");
    // }

    // if (
    //   this.isSlideVisible(
    //     this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
    //   )
    // ) {
    //   this.nextButton.setAttribute("disabled", "disabled");
    // } else {
    //   this.nextButton.removeAttribute("disabled");
    // }

    var ulElement = document.querySelector(".desktopthumbnail");
    var liElements = ulElement.getElementsByTagName("li");
    var visibleLiCount = 0;
    for (var i = 0; i < liElements.length; i++) {
      var liElement = liElements[i];
      var computedStyle = window.getComputedStyle(liElement);
      if (
        computedStyle.display !== "none" &&
        computedStyle.visibility !== "hidden"
      ) {
        visibleLiCount++;
      }
    }
    if (visibleLiCount > 7) {
      $(".slider-button--prev").css("display", "block");
      $(".slider-button--next").css("display", "block");
      //console.log("loadvisibleLiCount==="+visibleLiCount);
    } else {
      $(".slider-button--prev").css("display", "none");
      $(".slider-button--next").css("display", "none");
      //console.log("loadvisibleLiCount==="+visibleLiCount);
    }

    var sliderContainer = $(".slider_container_thumbnail");
    var slidesContainer = $(".desktopthumbnaillist");
    var slides = slidesContainer.find("li:visible");
    var totalSlides = slides.length;
    var slideHeight = slides.outerHeight();
    var currentSlide = 0;

    // Set initial active slide
    slides.eq(currentSlide).addClass("active");
    $(".slider-button-prev-thumb").attr("disabled", "disabled");
    $(".slider-button-next-thumb").removeAttr("disabled");

    // Next button click event
    $(".slider-button-next-thumb")
      .unbind()
      .click(function () {
        if (currentSlide < totalSlides - 1) {
          slides.eq(currentSlide).removeClass("active");
          currentSlide++;
          slides.eq(currentSlide).addClass("active");
          slides.eq(currentSlide).find(".listthumbnail").click();
          var scrollOffset = currentSlide * slideHeight;
          //console.log("visibleLiCount==="+totalSlides+"currentSlide=="+currentSlide);
          sliderContainer.animate({ scrollTop: scrollOffset }, 100);
          $(this).removeAttr("disabled");
          $(".slider-button-prev-thumb").removeAttr("disabled");
        } else {
          $(this).attr("disabled", "disabled");
          $(".slider-button-prev-thumb").removeAttr("disabled");
        }
      });

    // Previous button click event
    $(".slider-button-prev-thumb")
      .unbind()
      .click(function () {
        if (currentSlide > 0) {
          slides.eq(currentSlide).removeClass("active");
          currentSlide--;
          slides.eq(currentSlide).addClass("active");
          slides.eq(currentSlide).find(".listthumbnail").click();
          var scrollOffset = currentSlide * slideHeight;
          sliderContainer.animate({ scrollTop: scrollOffset }, 100);
          $(this).removeAttr("disabled");
          $(".slider-button-next-thumb").removeAttr("disabled");
        } else {
          $(this).attr("disabled", "disabled");
          $(".slider-button-next-thumb").removeAttr("disabled");
        }
      });
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientHeight + this.slider.scrollTop - offset;
    return (
      element.offsetTop + element.clientHeight <= lastVisibleSlide &&
      element.offsetTop >= this.slider.scrollTop
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    // const step = event.currentTarget.dataset.step || 1;

    // this.slideScrollPosition =
    //   event.currentTarget.name === "next"
    //     ? this.slider.scrollTop + step * this.sliderItemOffset
    //     : this.slider.scrollTop - step * this.sliderItemOffset;

    // console.log("this.slideScrollPosition==="+this.slideScrollPosition);

    // this.slider.scrollTo({
    //   top: this.slideScrollPosition,
    // });
  }
}

customElements.define("slider-component-desktop", SliderComponentDesktop);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;

    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;

    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    if ($(this).parents("quick-add-modal").length) {
    } else {
      //$("[thumbnail-color]").hide();//
      var selected_variant = $(".gallery-wrapper-main").data("mediaalt");
      var selected_attribute = '[thumbnail-color="' + selected_variant + '"]';
      $(selected_attribute).show();
    }

    // $('.thumbnail-list__item').click(function(){
    //   console.log("hey----");
    //   $(this).css({"border":"2px solid #63666a"});
    //   $(this).parent('.thumbnail-list').find('.thumbnail-list__item').css({"border":"0px solid #63666a"});
    // });
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.filterMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  filterMedia() {
    if (
      $("body").data("template") == "product" &&
      $("body").data("templatetype") != "bundle"
    ) {
      if ($("quick-add-modal[open]").length) {
        var selected_variant = this.currentVariant.featured_media.alt;
        $(
          ".quick-add-modal__content-info .slider-mobile-gutter .product__media-item"
        ).hide();
        var selected_slides_mobile =
          '.quick-add-modal__content-info .slider-mobile-gutter .product__media-item[data-mediaalt="' +
          selected_variant +
          '"]';
        $(selected_slides_mobile).show();
      } else {
        $("#MainProduct-" + this.dataset.section)
          .find("[thumbnail-color]")
          .hide();
        $(".modal-media--container .swiper-slide").hide();
        var selected_variant = this.currentVariant.featured_media.alt;
        var selected_attribute = '[thumbnail-color="' + selected_variant + '"]';
        var selected_slides =
          '.modal-media--container .swiper-slide[data-alt="' +
          selected_variant +
          '"]';
        $("#MainProduct-" + this.dataset.section)
          .find(selected_attribute)
          .show();
        $(selected_slides).show();

        this.mql = window.matchMedia("(max-width: 750px)");
        if (this.mql.matches) {
          $("#MainProduct-" + this.dataset.section)
            .find(".slider-mobile-gutter .product__media-item")
            .hide();
          var selected_slides_mobile =
            '.slider-mobile-gutter .product__media-item[data-mediaalt="' +
            selected_variant +
            '"]';
          $("#MainProduct-" + this.dataset.section)
            .find(selected_slides_mobile)
            .show();
        }

        if (window.matchMedia("(min-width: 991px)").matches) {
          var lengthdata = $(".product__media-wrapper").find(
            ".desktopthumbnaillist li"
          ).length;
          if (lengthdata > 0) {
            var ulElement = document.querySelector(".desktopthumbnail");
            var liElements = ulElement.getElementsByTagName("li");
            var visibleLiCount = 0;
            for (var i = 0; i < liElements.length; i++) {
              var liElement = liElements[i];
              var computedStyle = window.getComputedStyle(liElement);
              if (
                computedStyle.display !== "none" &&
                computedStyle.visibility !== "hidden"
              ) {
                visibleLiCount++;
              }
            }
            if (visibleLiCount > 7) {
              $(".slider-button--prev").css("display", "block");
              $(".slider-button--next").css("display", "block");
              //console.log("loadvisibleLiCount==="+visibleLiCount);
            } else {
              $(".slider-button--prev").css("display", "none");
              $(".slider-button--next").css("display", "none");
              //console.log("loadvisibleLiCount==="+visibleLiCount);
            }

            $(".slider_container_thumbnail").scrollTop(
              $(".desktopthumbnaillist li:nth-child(1)").position().top
            );
            $(".slider-button--prev").attr("disabled", "disabled");
            $(".slider-button--next").removeAttr("disabled");

            var sliderContainer = $(".slider_container_thumbnail");
            var slidesContainer = $(".desktopthumbnaillist");
            var slides = slidesContainer.find("li:visible");
            var totalSlides = slides.length;
            var slideHeight = slides.outerHeight();
            var currentSlide = 0;

            // Set initial active slide
            slides.eq(currentSlide).addClass("active");

            // Next button click event
            $(".slider-button-next-thumb")
              .unbind()
              .click(function () {
                if (currentSlide < totalSlides - 1) {
                  slides.eq(currentSlide).removeClass("active");
                  currentSlide++;
                  slides.eq(currentSlide).addClass("active");
                  slides.eq(currentSlide).find(".listthumbnail").click();
                  var scrollOffset = currentSlide * slideHeight;
                  sliderContainer.animate({ scrollTop: scrollOffset }, 100);
                  $(this).removeAttr("disabled");
                  $(".slider-button-prev-thumb").removeAttr("disabled");
                } else {
                  $(this).attr("disabled", "disabled");
                  $(".slider-button-prev-thumb").removeAttr("disabled");
                }
              });

            // Previous button click event
            $(".slider-button-prev-thumb")
              .unbind()
              .click(function () {
                if (currentSlide > 0) {
                  slides.eq(currentSlide).removeClass("active");
                  currentSlide--;
                  slides.eq(currentSlide).addClass("active");
                  slides.eq(currentSlide).find(".listthumbnail").click();
                  var scrollOffset = currentSlide * slideHeight;
                  sliderContainer.animate({ scrollTop: scrollOffset }, 100);
                  $(this).removeAttr("disabled");
                  $(".slider-button-next-thumb").removeAttr("disabled");
                } else {
                  $(this).attr("disabled", "disabled");
                  $(".slider-button-next-thumb").removeAttr("disabled");
                }
              });
          }
        }
      }
    } else if ($(".quick-add-modal").hasClass("quick-add-modal")) {
      if ($("quick-add-modal[open]").length) {
        var selected_variant = this.currentVariant.featured_media.alt;
        //console.log(selected_variant)
        $(
          ".quick-add-modal__content-info .slider-mobile-gutter .product__media-item"
        ).hide();
        var selected_slides_mobile =
          '.quick-add-modal__content-info .slider-mobile-gutter .product__media-item[data-mediaalt="' +
          selected_variant +
          '"]';
        $(selected_slides_mobile).show();
      } else {
        $("#MainProduct-" + this.dataset.section)
          .find("[thumbnail-color]")
          .hide();
        $(".modal-media--container .swiper-slide").hide();
        var selected_variant = this.currentVariant.featured_media.alt;
        var selected_attribute = '[thumbnail-color="' + selected_variant + '"]';
        var selected_slides =
          '.modal-media--container .swiper-slide[data-alt="' +
          selected_variant +
          '"]';
        $("#MainProduct-" + this.dataset.section)
          .find(selected_attribute)
          .show();
        $(selected_slides).show();

        this.mql = window.matchMedia("(max-width: 750px)");
        if (this.mql.matches) {
          $("#MainProduct-" + this.dataset.section)
            .find(".slider-mobile-gutter .product__media-item")
            .hide();
          var selected_slides_mobile =
            '.slider-mobile-gutter .product__media-item[data-mediaalt="' +
            selected_variant +
            '"]';
          $("#MainProduct-" + this.dataset.section)
            .find(selected_slides_mobile)
            .show();
        }

        if (window.matchMedia("(min-width: 991px)").matches) {
          var ulElement = document.querySelector(".desktopthumbnail");
          var liElements = ulElement.getElementsByTagName("li");
          var visibleLiCount = 0;
          for (var i = 0; i < liElements.length; i++) {
            var liElement = liElements[i];
            var computedStyle = window.getComputedStyle(liElement);
            if (
              computedStyle.display !== "none" &&
              computedStyle.visibility !== "hidden"
            ) {
              visibleLiCount++;
            }
          }
          if (visibleLiCount > 7) {
            $(".slider-button--prev").css("display", "block");
            $(".slider-button--next").css("display", "block");
            //console.log("loadvisibleLiCount==="+visibleLiCount);
          } else {
            $(".slider-button--prev").css("display", "none");
            $(".slider-button--next").css("display", "none");
            //console.log("loadvisibleLiCount==="+visibleLiCount);
          }

          $(".slider_container_thumbnail").scrollTop(
            $(".desktopthumbnaillist li:nth-child(1)").position().top
          );
          $(".slider-button--prev").attr("disabled", "disabled");
          $(".slider-button--next").removeAttr("disabled");

          var sliderContainer = $(".slider_container_thumbnail");
          var slidesContainer = $(".desktopthumbnaillist");
          var slides = slidesContainer.find("li:visible");
          var totalSlides = slides.length;
          var slideHeight = slides.outerHeight();
          var currentSlide = 0;

          // Set initial active slide
          slides.eq(currentSlide).addClass("active");

          // Next button click event
          $(".slider-button-next-thumb")
            .unbind()
            .click(function () {
              if (currentSlide < totalSlides - 1) {
                slides.eq(currentSlide).removeClass("active");
                currentSlide++;
                slides.eq(currentSlide).addClass("active");
                slides.eq(currentSlide).find(".listthumbnail").click();
                var scrollOffset = currentSlide * slideHeight;
                sliderContainer.animate({ scrollTop: scrollOffset }, 100);
                $(this).removeAttr("disabled");
                $(".slider-button-prev-thumb").removeAttr("disabled");
              } else {
                $(this).attr("disabled", "disabled");
                $(".slider-button-prev-thumb").removeAttr("disabled");
              }
            });

          // Previous button click event
          $(".slider-button-prev-thumb")
            .unbind()
            .click(function () {
              if (currentSlide > 0) {
                slides.eq(currentSlide).removeClass("active");
                currentSlide--;
                slides.eq(currentSlide).addClass("active");
                slides.eq(currentSlide).find(".listthumbnail").click();
                var scrollOffset = currentSlide * slideHeight;
                sliderContainer.animate({ scrollTop: scrollOffset }, 100);
                $(this).removeAttr("disabled");
                $(".slider-button-next-thumb").removeAttr("disabled");
              } else {
                $(this).attr("disabled", "disabled");
                $(".slider-button-next-thumb").removeAttr("disabled");
              }
            });
        }
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    $(".product__media-item--variant.is-active").show();
    //console.log("hello==");
    //modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    $(".selectedvarcolor").text(this.querySelector(":checked").value);
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const destinationquick = document.getElementById(
          `price-quick-${this.dataset.section}`
        );
        const sourcequick = html.getElementById(
          `price-quick-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const destinationcostper = document.getElementById(
          `accordion__content_cost`
        );
        const sourcecostper = html.getElementById(`accordion__content_cost`);
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (sourcequick && destinationquick)
          destinationquick.innerHTML = sourcequick.innerHTML;
        if (sourcecostper && destinationcostper)
          destinationcostper.innerHTML = sourcecostper.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        var cvariant = this.currentVariant;

        $(".custom_product_badge .badge").show();
        $(".preorder-input").remove();
        $(".custom_product_badge .preorder_badge").hide();
        $(".productaddsubmit").css("background-color", "#38393a");
        $(".preordertext").hide();
        $(".product-variants-all .product-variant-inner").each(function () {
          if ($(this).data("varid") == cvariant.id) {
            if (
              $(this).data("preorder") == true &&
              $(this).data("pravailable") == true
            ) {
              $(".custom_product_badge .badge").hide();
              $(".custom_product_badge .preorder_badge").show();
              $(".productaddsubmit").css("background-color", "#8E6A3D");
              $(".productaddsubmit .productadding").html("PREORDER NOW");
              $(".preordertext").show();
              $(".preordertext").html( $(this).attr("data-preordertext"));
              $(".productaddsubmit").before(`<input
              class="preorder-input"
              type="hidden"
              name="properties[Preorder]"
              value="${$(this).data("preordertext")}"
            >`);
              $(".preorder-accordian").show();
              $(".variant-preorder-content").hide();
              $(
                '.variant-preorder-content[data-varid="' + cvariant.id + '"]'
              ).show();
            } else {
              $(".preorder-accordian").hide();
            }
          }
        });

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    var mySwiper = undefined;
    function initSwiper() {
      var screenWidth = $(window).width();
      if (screenWidth <= 990 && mySwiper == undefined) {
        $(".slideshowcomp").each(function () {
          mySwiper = new Swiper(this, {
            slidesPerView: 2.3,
            spaceBetween: 0,
            navigation: {
              prevEl: ".swiper-button-prev-comp",
              nextEl: ".swiper-button-next-comp",
            },
          });
        });
      } else if (screenWidth > 991 && mySwiper != undefined) {
        mySwiper.destroy();
        mySwiper = undefined;
        //console.log("destroy");
        jQuery(".swiper-wrapper").removeAttr("style");
        jQuery(".swiper-slide").removeAttr("style");
      }
    }
    //Swiper plugin initialization
    initSwiper();
    //Swiper plugin initialization on window resize
    $(window).on("resize", function () {
      initSwiper();
    });
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }

          $(".showmorepill").click(function () {
            $(this)
              .parent(".custom_product_variant_container")
              .find(".custom_select_varcont")
              .css({ display: "block" });
            $(this).hide();
          });

          $(this)
            .find(".variants-pills")
            .click(function () {
              var thisto = $(this);
              var sel_var = $(this).attr("data-varimage");
              var sel_url = $(this).attr("data-varurl");
              $(this).parents(".product--item").find("a").attr("href", sel_url);
              $(this)
                .parents(".product--item")
                .find("modal-opener")
                .attr("data-product-url", sel_url);
              $(this)
                .parents(".product--item")
                .find(".quick-add__submit")
                .attr("data-product-url", sel_url);

              $(this)
                .parents(".product-card-wrapper")
                .find(".custom_card_media img")
                .attr("srcset", sel_var);
              $(this)
                .parents(".product-card-wrapper")
                .find(".variants-pills")
                .removeClass("selected");
              $(this).addClass("selected");

              var selectedcolor = $(this).data("colorname");
              var selectedsize = $(this)
                .parents(".custom-card-information")
                .find(".sizeselectedvar.selected .selectedvar")
                .text();
              var varname = selectedcolor + "/" + selectedsize;
              //console.log('varname==='+varname);
              $(this)
                .parents(".custom_card_product_main")
                .find(".comp_product_variants")
                .find("option")
                .each(function (index) {
                  var varoption1 = $(this).data("option1");
                  var varoption2 = $(this).data("option2");
                  var varoption3 = $(this).data("option3");

                  if (
                    varname.indexOf(varoption1) != -1 &&
                    varname.indexOf(varoption2) != -1 &&
                    varname.indexOf(varoption3) != -1
                  ) {
                    var currid = $(this).attr("value");

                    $(thisto)
                      .parents(".custom_card_product_main")
                      .find(".preordertextcart")
                      .hide();
                    $(thisto)
                      .parents(".custom_card_product_main")
                      .find(".preorder-input")
                      .remove();
                    $(thisto)
                      .parents(".custom_card_product_main")
                      .find(".complementry-variants-all")
                      .find(".product-variant-inner")
                      .each(function () {
                        if ($(this).data("varid") == currid) {
                          if (
                            $(this).data("preorder") == true &&
                            $(this).data("pravailable") == true
                          ) {
                            //console.log("currid=="+currid+"preorderid==="+$(this).data('varid'));
                            $(this)
                              .parents(".custom_card_product_main")
                              .find(".preordertextcart")
                              .show();
                            $(this)
                              .parents(".custom_card_product_main")
                              .find(".custom_complementary_addproduct")
                              .before(`<input
                              class="preorder-input"
                              type="hidden"
                              name="properties[Preorder]"
                              value="${$(this).data("preordertext")}"
                            >`);
                          }
                        }
                      });
                    // console.log("dsfjsd=="+$(this).attr("value"));
                    $(".complemetary_product_id").val($(this).attr("value"));
                  }
                });
            });

          $(".selected").click(function () {
            $(this)
              .parent(".custom_drop_down_size")
              .find(".sizeoptions ul")
              .toggle();
          });

          $(".sizeoptionslist li").click(function () {
            var thisto = $(this);
            var selectedvalue = $(this).data("value");
            $(this)
              .parent(".sizeoptionslist")
              .parent(".sizeoptions")
              .parent(".custom_drop_down_size")
              .find(".selected .selectedvar")
              .text(selectedvalue);
            $(".custom_drop_down_size .sizeoptions ul").hide();

            var selectedcolor = $(this)
              .parents(".custom-card-information")
              .find(".custom_variants_pills.selected")
              .data("colorname");
            var selectedsize = $(this).data("value");
            var varname = selectedcolor + "/" + selectedsize;
            //console.log("varname=="+varname);
            $(this)
              .parents(".custom_card_product_main")
              .find(".comp_recomm_product_variants")
              .find("option")
              .each(function (index) {
                var varoption1 = $(this).data("option1");
                var varoption2 = $(this).data("option2");
                var varoption3 = $(this).data("option3");

                if (
                  varname.indexOf(varoption1) != -1 &&
                  varname.indexOf(varoption2) != -1 &&
                  varname.indexOf(varoption3) != -1
                ) {
                  var currid = $(this).attr("value");
                  $(thisto)
                    .parents(".custom_card_product_main")
                    .find(".preordertextcart")
                    .hide();
                  $(thisto)
                    .parents(".custom_card_product_main")
                    .find(".preorder-input")
                    .remove();
                  $(thisto)
                    .parents(".custom_card_product_main")
                    .find(".complementry-variants-all")
                    .find(".product-variant-inner")
                    .each(function () {
                      if ($(this).data("varid") == currid) {
                        if (
                          $(this).data("preorder") == true &&
                          $(this).data("pravailable") == true
                        ) {
                          //console.log("currid=="+currid+"preorderid==="+$(this).data('varid'));
                          $(this)
                            .parents(".custom_card_product_main")
                            .find(".preordertextcart")
                            .show();
                          $(this)
                            .parents(".custom_card_product_main")
                            .find(".custom_complementary_addproduct")
                            .before(`<input
                              class="preorder-input"
                              type="hidden"
                              name="properties[Preorder]"
                              value="${$(this).data("preordertext")}"
                            >`);
                        }
                      }
                    });

                  //console.log("dsfjsd=="+currid);
                  $(".complemetary_product_id").val($(this).attr("value"));
                }
              });
          });

          $(document).bind("click", function (e) {
            var $clicked = $(e.target);
            if (!$clicked.parents().hasClass("custom_drop_down_size"))
              $(".custom_drop_down_size .sizeoptions ul").hide();
          });

          var mySwiper = undefined;
          function initSwiper() {
            var screenWidth = $(window).width();
            if (screenWidth <= 990 && mySwiper == undefined) {
              $(".slideshowcomp").each(function () {
                mySwiper = new Swiper(this, {
                  slidesPerView: 2.2,
                  spaceBetween: 20,
                  navigation: {
                    prevEl: ".swiper-button-prev-comp",
                    nextEl: ".swiper-button-next-comp",
                  },
                });
              });
            } else if (screenWidth > 991 && mySwiper != undefined) {
              mySwiper.destroy();
              mySwiper = undefined;
              //console.log("destroy");
              jQuery(".swiper-wrapper").removeAttr("style");
              jQuery(".swiper-slide").removeAttr("style");
            }
          }
          //Swiper plugin initialization
          initSwiper();
          //Swiper plugin initialization on window resize
          $(window).on("resize", function () {
            initSwiper();
          });

          $(document).ready(function () {
            new Swiper(".collectionrelatedSwiper", {
              slidesPerView: "auto",
              spaceBetween: 21,
              breakpoints: {
                767: {
                  slidesPerView: "auto",
                  spaceBetween: 21,
                },
                990: {
                  slidesPerView: "auto",
                  spaceBetween: 21,
                },

                1280: {
                  slidesPerView: "auto",
                  spaceBetween: 21,
                },

                1440: {
                  slidesPerView: 4,
                  spaceBetween: 21,
                },
              },
              navigation: {
                nextEl: ".swiper-button-next-shop",
                prevEl: ".swiper-button-prev-shop",
              },
            });
          });
          $(document).ready(function () {
            var symbol = $("body").data("currency");
            $(".bundelprice").each(function () {
              var price = Number($(this).data("price"));
              var cprice = price * Shopify.currency.rate;
              $(this).html(Shopify.formatMoney(cprice, symbol + "{{amount}}"));
            });
          });
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class CustomShopCollection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".showmorepill").click(function () {
        $(this)
          .parent(".custom_product_variant_container")
          .find(".custom_select_varcont")
          .css({ display: "block" });
        $(this).hide();
      });

      $(this).find(".main-title").eq(0).addClass("active");
      $(this).find(".collection-slider").css({ display: "none" });
      var first_block = $(this).find(".main-title").eq(0).attr("data-heading");
      $(this)
        .find(".collection-slider[title ='" + first_block + "']")
        .css("display", "block");

      $(this).find(".collectionSwiper .swiper-wrapper").css({ opacity: "1" });
      $(".main-title").click(function () {
        $(this)
          .parent(".swiper-wrapper")
          .parent(".lower--section")
          .parent(".shop-by-collection")
          .find(".collection-slider")
          .css({ display: "none" });
        $(this)
          .parent(".swiper-wrapper")
          .parent(".lower--section")
          .find(".main-title")
          .removeClass("active");
        var heading = $(this).attr("data-heading");
        $(this).addClass("active");
        $(this)
          .parent(".swiper-wrapper")
          .parent(".lower--section")
          .parent(".shop-by-collection")
          .find(".collection-slider[title ='" + heading + "']")
          .css("display", "block");
      });

      var paginationid =
        ".custom_swiper_pagination_" + this.getAttribute("data-sectionid");
      //console.log(paginationid + " ff");

      this.this2 = this;

      var paginationid =
        ".custom_swiper_pagination_" + this.getAttribute("data-sectionid");
      this.swiper = new Swiper(
        ".collectionSwiper-" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: "auto",
          spaceBetween: 21,
          pagination: {
            el: paginationid,
            clickable: true,
          },
          breakpoints: {
            767: {
              slidesPerView: "auto",
              spaceBetween: 21,
            },
            990: {
              slidesPerView: "auto",
              spaceBetween: 21,
            },

            1280: {
              slidesPerView: "auto",
              spaceBetween: 21,
            },

            1440: {
              slidesPerView: 4,
              spaceBetween: 21,
            },
          },
          navigation: {
            nextEl: ".swiper-button-next-shop",
            prevEl: ".swiper-button-prev-shop",
          },
        }
      );

      var newmySwiper = undefined;
      function initSwiper() {
        var screenWidth = $(window).width();
        if (screenWidth <= 990 && newmySwiper == undefined) {
          $(".swipernavigation").each(function () {
            newmySwiper = new Swiper(this, {
              freeMode: true,
              slidesPerView: "auto",
              spaceBetween: 40,
            });
          });
        } else if (screenWidth > 991 && newmySwiper != undefined) {
          newmySwiper.destroy();
          newmySwiper = undefined;
          //console.log("destroy");
          jQuery(".swiper-wrapper").removeAttr("style");
          jQuery(".swiper-slide").removeAttr("style");
        }
      }
      //Swiper plugin initialization
      initSwiper();
      //Swiper plugin initialization on window resize
      $(window).on("resize", function () {
        initSwiper();
      });

      $(this)
        .find(".variants-pills")
        .click(function () {
          var sel_var = $(this).attr("data-varimage");
          var sel_url = $(this).attr("data-varurl");

          $(this).parents(".product--item").find("a").attr("href", sel_url);

          $(this)
            .parents(".product--item")
            .find("modal-opener")
            .attr("data-product-url", sel_url);
          $(this)
            .parents(".product--item")
            .find(".quick-add__submit")
            .attr("data-product-url", sel_url);
          $(this)
            .parents(".product--item")
            .find(".image-container img")
            .attr("src", sel_var);

          $(this)
            .parents(".product--item")
            .find(".variants-pills")
            .removeClass("selected");
          $(this).addClass("selected");
        });

      var newmySwiper = undefined;
      function initSwiper() {
        var screenWidth = $(window).width();
        if (screenWidth <= 990 && newmySwiper == undefined) {
          $(".swipernavigation").each(function () {
            newmySwiper = new Swiper(this, {
              freeMode: true,
              slidesPerView: "auto",
              spaceBetween: 30,
            });
          });
        } else if (screenWidth > 991 && newmySwiper != undefined) {
          newmySwiper.destroy();
          newmySwiper = undefined;
          //console.log("destroy");
          jQuery(".swiper-wrapper").removeAttr("style");
          jQuery(".swiper-slide").removeAttr("style");
        }
      }
      //Swiper plugin initialization
      initSwiper();
      //Swiper plugin initialization on window resize
      $(window).on("resize", function () {
        initSwiper();
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("shop-custom-collection", CustomShopCollection);

class CustomShopCollection2 extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".showmorepill").click(function () {
        $(this)
          .parent(".custom_product_variant_container")
          .find(".custom_select_varcont")
          .css({ display: "block" });
        $(this).hide();
      });

      $(this).find(".main-title").eq(0).addClass("active");
      $(this).find(".collection-slider").css({ display: "none" });
      var first_block = $(this).find(".main-title").eq(0).attr("data-heading");
      $(this)
        .find(".collection-slider[title ='" + first_block + "']")
        .css("display", "block");

      $(this).find(".collectionSwiper .swiper-wrapper").css({ opacity: "1" });
      $(".main-title").click(function () {
        $(this)
          .parent(".swiper-wrapper")
          .parent(".lower--section")
          .parent(".shop-by-collection")
          .find(".collection-slider")
          .css({ display: "none" });
        $(this)
          .parent(".swiper-wrapper")
          .parent(".lower--section")
          .find(".main-title")
          .removeClass("active");
        var heading = $(this).attr("data-heading");
        $(this).addClass("active");
        $(this)
          .parent(".swiper-wrapper")
          .parent(".lower--section")
          .parent(".shop-by-collection")
          .find(".collection-slider[title ='" + heading + "']")
          .css("display", "block");
      });

      var paginationid =
        ".custom_swiper_pagination_" + this.getAttribute("data-sectionid");
      //console.log(paginationid + " ff");

      this.this2 = this;

      var paginationid =
        ".custom_swiper_pagination_" + this.getAttribute("data-sectionid");
      this.swiper = new Swiper(
        ".collectionSwiper-" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: "auto",
          spaceBetween: 21,
          pagination: {
            el: paginationid,
            clickable: true,
          },
          breakpoints: {
            767: {
              slidesPerView: "auto",
              spaceBetween: 21,
            },
            990: {
              slidesPerView: "auto",
              spaceBetween: 21,
            },

            1280: {
              slidesPerView: "auto",
              spaceBetween: 21,
            },

            1440: {
              slidesPerView: 4,
              spaceBetween: 21,
            },
          },
          navigation: {
            nextEl: ".swiper-button-next-shop",
            prevEl: ".swiper-button-prev-shop",
          },
        }
      );

      var newmySwiper = undefined;
      function initSwiper() {
        var screenWidth = $(window).width();
        if (screenWidth <= 990 && newmySwiper == undefined) {
          $(".swipernavigation").each(function () {
            newmySwiper = new Swiper(this, {
              freeMode: true,
              slidesPerView: "auto",
              spaceBetween: 40,
            });
          });
        } else if (screenWidth > 991 && newmySwiper != undefined) {
          newmySwiper.destroy();
          newmySwiper = undefined;
          // console.log("destroy");
          jQuery(".swiper-wrapper").removeAttr("style");
          jQuery(".swiper-slide").removeAttr("style");
        }
      }
      //Swiper plugin initialization
      initSwiper();
      //Swiper plugin initialization on window resize
      $(window).on("resize", function () {
        initSwiper();
      });

      $(this)
        .find(".variants-pills")
        .click(function () {
          var sel_var = $(this).attr("data-varimage");
          var sel_url = $(this).attr("data-varurl");
          $(this).parents(".product--item").find("a").attr("href", sel_url);
          $(this)
            .parents(".product--item")
            .find("modal-opener")
            .attr("data-product-url", sel_url);
          $(this)
            .parents(".product--item")
            .find(".quick-add__submit")
            .attr("data-product-url", sel_url);
          $(this)
            .parents(".product--item")
            .find(".image-container img")
            .attr("src", sel_var);
          $(this)
            .parents(".product--item")
            .find(".variants-pills")
            .removeClass("selected");
          $(this).addClass("selected");
        });

      var newmySwiper = undefined;
      function initSwiper() {
        var screenWidth = $(window).width();
        if (screenWidth <= 990 && newmySwiper == undefined) {
          $(".swipernavigation").each(function () {
            newmySwiper = new Swiper(this, {
              freeMode: true,
              slidesPerView: "auto",
              spaceBetween: 30,
            });
          });
        } else if (screenWidth > 991 && newmySwiper != undefined) {
          newmySwiper.destroy();
          newmySwiper = undefined;
          //console.log("destroy");
          jQuery(".swiper-wrapper").removeAttr("style");
          jQuery(".swiper-slide").removeAttr("style");
        }
      }
      //Swiper plugin initialization
      initSwiper();
      //Swiper plugin initialization on window resize
      $(window).on("resize", function () {
        initSwiper();
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("shop-custom-collection-2", CustomShopCollection2);

class Multiimgwithcontent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).find(".main-title").eq(0).addClass("active");
      $(this).find(".multiimgwithtextmain").css({ display: "none" });
      var first_block = $(this).find(".main-title").eq(0).attr("data-heading");
      $(this)
        .find(".multiimgwithtextmain[title ='" + first_block + "']")
        .css("display", "grid");

      $(this).find(".collectionSwiper .swiper-wrapper").css({ opacity: "1" });
      $(".main-title").click(function () {
        $(this)
          .parent(".swiper-wrapper")
          .parent(".multi--lower--section")
          .parent(".multi-img-with-content-wrapper")
          .find(".multiimgwithtextmain")
          .css({ display: "none" });
        $(this)
          .parent(".swiper-wrapper")
          .parent(".multi--lower--section")
          .find(".main-title")
          .removeClass("active");
        var heading = $(this).attr("data-heading");
        // console.log("heading==" + heading);
        $(this).addClass("active");
        $(this)
          .parent(".swiper-wrapper")
          .parent(".multi--lower--section")
          .parent(".multi-img-with-content-wrapper")
          .find(".multiimgwithtextmain[title ='" + heading + "']")
          .css("display", "grid");
      });

      var newmySwiper = undefined;
      function initSwiper() {
        var screenWidth = $(window).width();
        if (screenWidth <= 990 && newmySwiper == undefined) {
          $(".multiswipernavigation").each(function () {
            newmySwiper = new Swiper(this, {
              slidesPerView: "auto",
              spaceBetween: 20,
            });
          });
        } else if (screenWidth > 991 && newmySwiper != undefined) {
          newmySwiper.destroy();
          newmySwiper = undefined;
          //console.log("destroy");
          jQuery(".swiper-wrapper").removeAttr("style");
          jQuery(".swiper-slide").removeAttr("style");
        }
      }
      //Swiper plugin initialization
      initSwiper();
      //Swiper plugin initialization on window resize
      $(window).on("resize", function () {
        initSwiper();
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("multi-img-with-content", Multiimgwithcontent);

class CustomShopCollectionblog extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this)
        .find(".variants-pills")
        .click(function () {
          var sel_var = $(this).attr("data-varimage");
          var sel_url = $(this).attr("data-varurl");
          $(this).parents(".product--item").find("a").attr("href", sel_url);
          $(this)
            .parents(".product--item")
            .find("modal-opener")
            .attr("data-product-url", sel_url);
          $(this)
            .parents(".product--item")
            .find(".quick-add__submit")
            .attr("data-product-url", sel_url);
          $(this)
            .parents(".product--item")
            .find(".image-container img")
            .attr("src", sel_var);
          $(this)
            .parents(".product--item")
            .find(".variants-pills")
            .removeClass("selected");
          $(this).addClass("selected");
        });

      var mySwiper = undefined;
      function initSwiper() {
        var screenWidth = $(window).width();
        if (screenWidth <= 990 && mySwiper == undefined) {
          $(".collectionSwiper").each(function () {
            mySwiper = new Swiper(this, {
              slidesPerView: 4,
              spaceBetween: 10,
            });
          });
        } else if (screenWidth > 991 && mySwiper != undefined) {
          mySwiper.destroy();
          mySwiper = undefined;
          //console.log("destroy");
          jQuery(".swiper-wrapper").removeAttr("style");
          jQuery(".swiper-slide").removeAttr("style");
        }
      }
      //Swiper plugin initialization
      initSwiper();
      //Swiper plugin initialization on window resize
      $(window).on("resize", function () {
        initSwiper();
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("shop-custom-collection-blog", CustomShopCollectionblog);

class gethelook extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".showmorepill").click(function () {
        $(this)
          .parent(".custom_product_variant_container")
          .find(".custom_select_varcont")
          .css({ display: "block" });
        $(this).hide();
      });

      var swiper = new Swiper(".product-slider", {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: "fade",
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-button-next-get",
          prevEl: ".swiper-button-prev-get",
        },
        pagination: {
          el: ".swiper-pagination-get",
          clickable: true,
        },
      });

      var swiper2 = new Swiper(".get-thelook-slider", {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: "fade",
      });

      swiper.on("slideChangeTransitionEnd", function () {
        $(".select-error").hide();
      });

      swiper.controller.control = swiper2;
      swiper2.controller.control = swiper;

      $(".variants-pills").click(function () {
        var sel_var = $(this).attr("data-varimage");
        var sel_var_id = $(this).attr("data-varid");
        var sel_url = $(this).attr("data-varurl");
        $(this).parents(".product--item").find("a").attr("href", sel_url);
        $(this)
          .parents(".product--item")
          .find("modal-opener")
          .attr("data-product-url", sel_url);
        $(this)
          .parents(".product--item")
          .find(".quick-add__submit")
          .attr("data-product-url", sel_url);

        $(this)
          .parents(".product-item")
          .find(".product_item_link")
          .attr("data-productid", sel_var_id);
        $(this)
          .parents(".product-item")
          .find(".product-image img")
          .attr("src", sel_var);
        $(this)
          .parents(".product-item")
          .find(".variants-pills")
          .removeClass("selected");
        $(this).addClass("selected");
        $(this).parents(".product-item").find(".select-error-color").hide();
      });

      $(".mayyouselected ")
        .unbind()
        .on("click", function () {
          if (
            $(this)
              .parent(".get_drop_down_size")
              .find(".sizeoptions .getsizeoptionslist")
              .hasClass("show")
          ) {
            $(".get_drop_down_size")
              .find(".sizeoptions .getsizeoptionslist")
              .not(this)
              .removeClass("show");
            $(this)
              .parent(".get_drop_down_size")
              .find(".sizeoptions .getsizeoptionslist")
              .removeClass("show");
          } else {
            $(".get_drop_down_size")
              .find(".sizeoptions .getsizeoptionslist")
              .not(this)
              .removeClass("show");
            $(this)
              .parent(".get_drop_down_size")
              .find(".sizeoptions .getsizeoptionslist")
              .addClass("show");
          }
        });

      $(".getsizeoptionslist li").click(function () {
        var selectedvalue = $(this).data("value");
        $(this)
          .parent(".getsizeoptionslist")
          .parent(".sizeoptions")
          .parent(".get_drop_down_size")
          .find(".selected .selectedvar")
          .text(selectedvalue);
        $(".get_drop_down_size .sizeoptions .getsizeoptionslist").removeClass(
          "show"
        );
      });

      $(".custom_navigation_btn").click(function () {
        $(".swiper-slide-active .select-error").hide();

        var id_array = [];
        var array_preorder_content = [];
        var allchecked = true;
        $(".custom_getthelook_product.swiper-slide-active")
          .find(".main-variants")
          .each(function (index) {
            var size = "";
            var color = "";
            if (
              $(this).parents(".product-item").find(".selectedvar").length != 0
            ) {
              size = $(this)
                .parents(".product-item")
                .find(".selectedvar")
                .text();
            }
            if (
              $(this).parents(".product-item").find(".color-select").length != 0
            ) {
              color = $(this)
                .parents(".product-item")
                .find(".color-select")
                .find(".selected")
                .attr("value");
            }
            var this2 = this;
            if (
              $(this)
                .parents(".product-item")
                .find(".color-select")
                .find(".selected").length == 0
            ) {
              $(this)
                .parents(".product-item")
                .find(".select-error-color")
                .show();
              $(this)
                .parents(".product-item")
                .find(".select-error-color .errormsg")
                .html("Please select colour");
              allchecked = false;
            }

            if (size != "" && color != "") {
              $(this)
                .find("option")
                .each(function (i) {
                  var ctext = $(this).text();
                  var carr = ctext.split("/").map(function (item) {
                    return item.trim();
                  });
                  console.log(size + " " + color);
                  if (carr.indexOf(size) != -1 && carr.indexOf(color) != -1) {
                    console.log(size + " " + color);
                    //console.log($(this).attr("value"));

                    var varname = color + "/" + size;
                    var currid = $(this).attr("value");
                    $(this2)
                      .parents(".custom_getthelook_product ")
                      .find(".preordertextcart")
                      .hide();
                    $(this2)
                      .parents(".custom_getthelook_product ")
                      .find(".preorder-input")
                      .remove();
                    $(this2)
                      .parents(".custom_getthelook_product ")
                      .find(".get-look-variants-all")
                      .find(".product-variant-inner")
                      .each(function () {
                        if ($(this).data("varid") == currid) {
                          if (
                            $(this).data("preorder") == true &&
                            $(this).data("pravailable") == true
                          ) {
                            $(this)
                              .parents(".custom_getthelook_product ")
                              .find(".preordertextcart")
                              .show();
                            $(this)
                              .parents(".custom_getthelook_product")
                              .find(".get-look-variants-all").after(`<input
                              class="preorder-input"
                              type="hidden"
                              name="properties[Preorder]"
                              data-preorderid = "${$(this).data("varid")}"
                              value="${$(this).data("preordertext")}"
                            >`);
                            array_preorder_content.push(
                              $(this).data("preordertext")
                            );
                          } else {
                            array_preorder_content.push("");
                          }
                        }
                      });
                    id_array.push($(this).attr("value"));
                  }
                });
            } else if (size == "") {
              $(this)
                .find("option")
                .each(function (i) {
                  var ctext = $(this).text();
                  console.log(color);
                  if (ctext == color) {
                    console.log(color + " gfgfg color");
                    //console.log($(this).attr("value"));

                    var varname = color + "/" + size;
                    var currid = $(this).attr("value");
                    $(this2)
                      .parents(".custom_getthelook_product ")
                      .find(".preordertextcart")
                      .hide();
                    $(this2)
                      .parents(".custom_getthelook_product ")
                      .find(".preorder-input")
                      .remove();
                    $(this2)
                      .parents(".custom_getthelook_product ")
                      .find(".get-look-variants-all")
                      .find(".product-variant-inner")
                      .each(function () {
                        if ($(this).data("varid") == currid) {
                          if (
                            $(this).data("preorder") == true &&
                            $(this).data("pravailable") == true
                          ) {
                            $(this)
                              .parents(".custom_getthelook_product ")
                              .find(".preordertextcart")
                              .show();
                            $(this)
                              .parents(".custom_getthelook_product")
                              .find(".get-look-variants-all").after(`<input
                              class="preorder-input"
                              type="hidden"
                              name="properties[Preorder]"
                              data-preorderid = "${$(this).data("varid")}"
                              value="${$(this).data("preordertext")}"
                            >`);
                            array_preorder_content.push(
                              $(this).data("preordertext")
                            );
                          } else {
                            array_preorder_content.push("");
                          }
                        }
                      });
                    id_array.push($(this).attr("value"));
                  }
                });
            } else if (color == "") {
              $(this)
                .find("option")
                .each(function (i) {
                  var ctext = $(this).text();
                  console.log(size + " gfgfg color");
                  if (ctext == size) {
                    console.log(size);
                    //console.log($(this).attr("value"));

                    var varname = color + "/" + size;
                    var currid = $(this).attr("value");
                    $(this2)
                      .parents(".custom_getthelook_product ")
                      .find(".preordertextcart")
                      .hide();
                    $(this2)
                      .parents(".custom_getthelook_product ")
                      .find(".preorder-input")
                      .remove();
                    $(this2)
                      .parents(".custom_getthelook_product ")
                      .find(".get-look-variants-all")
                      .find(".product-variant-inner")
                      .each(function () {
                        if ($(this).data("varid") == currid) {
                          if (
                            $(this).data("preorder") == true &&
                            $(this).data("pravailable") == true
                          ) {
                            $(this)
                              .parents(".custom_getthelook_product ")
                              .find(".preordertextcart")
                              .show();
                            $(this)
                              .parents(".custom_getthelook_product")
                              .find(".get-look-variants-all").after(`<input
                              class="preorder-input"
                              type="hidden"
                              name="properties[Preorder]"
                              data-preorderid = "${$(this).data("varid")}"
                              value="${$(this).data("preordertext")}"
                            >`);
                            array_preorder_content.push(
                              $(this).data("preordertext")
                            );
                          } else {
                            array_preorder_content.push("");
                          }
                        }
                      });
                    id_array.push($(this).attr("value"));
                  }
                });
            }
          });

        if (allchecked == true) {
          this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
          $(".custom_navigation_btn .cta-button").text("Adding...");
          $(".get-the-look-products .cta-button").css("pointer-events", "none");
          $(".get-the-look-products .cta-button").css("opacity", "0.5");
          var qty = 1;
          var data = {
            quantity: qty,
            id: id_array,
            sections: this.cart
              .getSectionsToRender()
              .map((section) => section.id),
            sections_url: window.location.pathname,
          };
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const formData = new FormData();
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          formData.append("form_type", "product");
          for (let index = 0; index < id_array.length; index++) {
            if (array_preorder_content[index] == "") {
              formData.append("items[" + index + "][id]", id_array[index]);
              formData.append("items[" + index + "][quantity]", 1);
            } else {
              formData.append("items[" + index + "][id]", id_array[index]);
              formData.append(
                "items[" + index + "][properties][Preorder]",
                array_preorder_content[index]
              );
              formData.append("items[" + index + "][quantity]", 1);
            }
          }

          config.body = formData;
          var this2 = this;
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                $(".custom_navigation_btn").after(`<svg
                        aria-hidden="true"
                        focusable="false"
                        class="icon icon-error"
                        viewBox="0 0 13 13"
                      >
                        <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
                        <circle cx="6.5" cy="6.5" r="5.5" fill="#8E6A3D" stroke="#8E6A3D" stroke-width="0.7"/>
                        <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
                        <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#8E6A3D" stroke-width="0.7">
                      </svg>
                      <span class="errormsg">${response.description}</span>`);
                return;
              }

              var discounttype = $(
                ".discount-wrapper-shop .discount-type"
              ).html();
              if (discounttype == "product") {
                var step = $(".discount-wrapper-shop").data("step");
                var pid1 = $(".discount-wrapper-shop .step-1-product").html();
                var pid2 = $(".discount-wrapper-shop .step-2-product").html();
                var pid3 = $(".discount-wrapper-shop .step-3-product").html();
                var hasvariant1 = $(
                  ".discount-wrapper-shop .step-1-hasvariant"
                ).html();
                var hasvariant2 = $(
                  ".discount-wrapper-shop .step-2-hasvariant"
                ).html();
                var hasvariant3 = $(
                  ".discount-wrapper-shop .step-3-hasvariant"
                ).html();
                var threshhold1 =
                  Number(
                    $(".discount-wrapper-shop .step-1-threshhold").html()
                  ) * 100;
                var threshhold2 =
                  Number(
                    $(".discount-wrapper-shop .step-2-threshhold").html()
                  ) * 100;
                var threshhold3 =
                  Number(
                    $(".discount-wrapper-shop .step-3-threshhold").html()
                  ) * 100;
                var addproduct = false;
                var addvarid = pid1;
                console.log(threshhold1 + " gfg");
                console.log(threshhold2 + " gfg");
                console.log(threshhold3 + " gfg");

                fetch("/cart.js")
                  .then((resp) => resp.json())
                  .then((resp) => {
                    var found = false;
                    var varid = "";
                    var removeids = [];
                    if (step == "step1") {
                      if (resp.total_price >= threshhold1) {
                        var found = false;
                        for (var i = 0; i < resp.items.length; i++) {
                          if (
                            resp.items[i].variant_id == pid1 &&
                            resp.items[i].properties.hasOwnProperty(
                              "_freeproduct"
                            ) == true
                          ) {
                            found = true;
                          } else {
                            if (
                              resp.items[i].properties.hasOwnProperty(
                                "_freeproduct"
                              )
                            ) {
                              removeids.push(resp.items[i].variant_id);
                            }
                          }
                        }
                        if (found == false && hasvariant1 == "true") {
                          addproduct = true;
                          addvarid = pid1;
                        }
                      }
                    }
                    if (step == "step2") {
                      if (
                        resp.total_price >= threshhold1 &&
                        resp.total_price < threshhold2
                      ) {
                        var found = false;
                        for (var i = 0; i < resp.items.length; i++) {
                          if (
                            resp.items[i].variant_id == pid1 &&
                            resp.items[i].properties.hasOwnProperty(
                              "_freeproduct"
                            ) == true
                          ) {
                            found = true;
                          } else {
                            if (
                              resp.items[i].properties.hasOwnProperty(
                                "_freeproduct"
                              )
                            ) {
                              removeids.push(resp.items[i].variant_id);
                            }
                          }
                        }
                        if (found == false && hasvariant1 == "true") {
                          addproduct = true;
                          addvarid = pid1;
                        }
                      } else if (
                        resp.total_price >= threshhold2 &&
                        resp.items[i].properties.hasOwnProperty(
                          "_freeproduct"
                        ) == true
                      ) {
                        var found = false;
                        for (var i = 0; i < resp.items.length; i++) {
                          if (resp.items[i].variant_id == pid2) {
                            found = true;
                          } else {
                            if (
                              resp.items[i].properties.hasOwnProperty(
                                "_freeproduct"
                              )
                            ) {
                              removeids.push(resp.items[i].variant_id);
                            }
                          }
                        }
                        if (found == false && hasvariant2 == "true") {
                          addproduct = true;
                          addvarid = pid2;
                        }
                      }
                    }
                    if (step == "step3") {
                      if (
                        resp.total_price >= threshhold1 &&
                        resp.total_price < threshhold2
                      ) {
                        console.log("test");
                        var found = false;
                        for (var i = 0; i < resp.items.length; i++) {
                          if (
                            resp.items[i].variant_id == pid1 &&
                            resp.items[i].properties.hasOwnProperty(
                              "_freeproduct"
                            ) == true
                          ) {
                            found = true;
                          } else {
                            if (
                              resp.items[i].properties.hasOwnProperty(
                                "_freeproduct"
                              )
                            ) {
                              removeids.push(resp.items[i].variant_id);
                            }
                          }
                        }
                        if (found == false && hasvariant1 == "true") {
                          addproduct = true;
                          addvarid = pid1;
                        }
                      } else if (
                        resp.total_price >= threshhold2 &&
                        resp.total_price < threshhold3
                      ) {
                        var found = false;
                        for (var i = 0; i < resp.items.length; i++) {
                          if (
                            resp.items[i].variant_id == pid2 &&
                            resp.items[i].properties.hasOwnProperty(
                              "_freeproduct"
                            ) == true
                          ) {
                            found = true;
                          } else {
                            if (
                              resp.items[i].properties.hasOwnProperty(
                                "_freeproduct"
                              )
                            ) {
                              removeids.push(resp.items[i].variant_id);
                            }
                          }
                        }
                        if (found == false && hasvariant2 == "true") {
                          addproduct = true;
                          addvarid = pid2;
                        }
                      } else if (resp.total_price >= threshhold3) {
                        var found = false;
                        for (var i = 0; i < resp.items.length; i++) {
                          if (
                            resp.items[i].variant_id == pid3 &&
                            resp.items[i].properties.hasOwnProperty(
                              "_freeproduct"
                            ) == true
                          ) {
                            found = true;
                          } else {
                            if (
                              resp.items[i].properties.hasOwnProperty(
                                "_freeproduct"
                              )
                            ) {
                              removeids.push(resp.items[i].variant_id);
                            }
                          }
                          if (found == false && hasvariant3 == "true") {
                            addproduct = true;
                            addvarid = pid3;
                          }
                        }
                      }
                    }
                    if (resp.total_price < threshhold1) {
                      var found = false;
                      for (var i = 0; i < resp.items.length; i++) {
                        if (
                          resp.items[i].properties.hasOwnProperty(
                            "_freeproduct"
                          )
                        ) {
                          removeids.push(resp.items[i].variant_id);
                          addproduct = true;
                        }
                      }
                    }
                    console.log("addproduct = " + addproduct);

                    if (addproduct == true) {
                      if (removeids.length > 0) {
                        var updates = {};
                        for (let index = 0; index < removeids.length; index++) {
                          updates[removeids[index]] = 0;
                        }

                        const bodyup = JSON.stringify({
                          updates: updates,
                          sections: this.getSectionsToRender().map(
                            (section) => section.section
                          ),
                          sections_url: window.location.pathname,
                        });

                        var this3 = this;

                        fetch(`/cart/update.js`, {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                          },
                          body: bodyup,
                        })
                          .then((response) => {
                            return response.text();
                          })
                          .then((state) => {
                            addnewproduct();
                          })
                          .catch(() => {
                            addnewproduct();
                          })
                          .finally(() => {});
                      } else {
                        addnewproduct();
                      }
                    } else {
                      if (removeids.length > 0) {
                        var updates = {};
                        for (let index = 0; index < removeids.length; index++) {
                          updates[removeids[index]] = 0;
                        }

                        const bodyup = JSON.stringify({
                          updates: updates,
                          sections: this2
                            .getSectionsToRender()
                            .map((section) => section.section),
                          sections_url: window.location.pathname,
                        });

                        var this3 = this;

                        fetch(`/cart/update.js`, {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                          },
                          body: bodyup,
                        })
                          .then((response) => {
                            return response.text();
                          })
                          .then((state) => {
                            addnewproduct();
                          })
                          .catch(() => {
                            addnewproduct();
                          })
                          .finally(() => {});
                      } else {
                        if (resp.total_price == 0) {
                          const body = JSON.stringify({
                            sections: this2.cart
                              .getSectionsToRender()
                              .map((section) => section.id),
                            sections_url: window.location.pathname,
                          });

                          fetch(`/cart/clear.js`, {
                            ...fetchConfig(),
                            ...{ body },
                          })
                            .then((response) => {
                              return response.text();
                            })
                            .then((state) => {
                              loadData(state);
                            })
                            .catch(() => {});
                        } else {
                          loadData(response);
                        }
                      }
                    }
                    function addnewproduct() {
                      var variantId = addvarid;

                      const body = JSON.stringify({
                        id: variantId,
                        quantity: 1,
                        properties: { _freeproduct: "true" },
                        sections: this2.cart
                          .getSectionsToRender()
                          .map((section) => section.id),
                        sections_url: window.location.pathname,
                      });

                      fetch(`/cart/add.js`, { ...fetchConfig(), ...{ body } })
                        .then((response) => {
                          return response.text();
                        })
                        .then((state) => {
                          var resp = JSON.parse(state);
                          loadData(resp);
                        })
                        .catch(() => {});
                    }
                  });
              } else {
                loadData(response);
              }

              function loadData(response) {
                $(".custom_navigation_btn .cta-button").text("SHOP THE SET");
                $(".get-the-look-products .cta-button").css(
                  "pointer-events",
                  "intial"
                );
                $(".get-the-look-products .cta-button").css("opacity", "1");

                this2.cart.renderContents(response);
              }
            });
        }
      });
      $(".size-select").change(function () {
        $(this).parents(".product-item").find(".select-error-size").hide();
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("get-the-look", gethelook);

class customcollectionslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.swiper = new Swiper(
        ".slider-enable-" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: "auto",
          spaceBetween: 20,
          navigation: {
            nextEl: ".swiper-button-next-slider",
            prevEl: ".swiper-button-prev-slider",
          },
          pagination: {
            clickable: true,
            el:
              ".swiper-pagination-slider-" +
              this.getAttribute("data-sectionid"),
          },
          breakpoints: {
            768: {
              slidesPerView: "auto",
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: "auto",
              spaceBetween: 16,
            },
            1280: {
              slidesPerView: "auto",
              spaceBetween: 16,
            },
            1440: {
              slidesPerView: "auto",
              spaceBetween: 16,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-collection-slider", customcollectionslider);

class customproductcollectionslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.swiper = new Swiper(
        ".slider-enable-" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: "auto",
          spaceBetween: 18,
          navigation: {
            nextEl: ".swiper-button-next-slider",
            prevEl: ".swiper-button-prev-slider",
          },
          pagination: {
            clickable: true,
            el:
              ".swiper-pagination-slider-" +
              this.getAttribute("data-sectionid"),
          },
          breakpoints: {
            768: {
              slidesPerView: "auto",
              spaceBetween: 18,
            },
            1024: {
              slidesPerView: "auto",
              spaceBetween: 16,
            },
            1280: {
              slidesPerView: "auto",
              spaceBetween: 16,
            },
            1440: {
              slidesPerView: "auto",
              spaceBetween: 16,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define(
  "custom-product-collection-slider",
  customproductcollectionslider
);

class HonestReview extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiperhonesttablet = new Swiper(".tablet-view .honest-slider", {
        spaceBetween: 5,
        pagination: {
          el: ".honest-pagination.mobile",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        },
        navigation: {
          nextEl: ".arrow-grid .right-arrow",
          prevEl: ".arrow-grid .left-arrow",
        },
        breakpoints: {
          560: {
            slidesPerView: "auto",
            spaceBetween: 48,
            pagination: {
              el: ".honest-pagination.mobile",
            },
          },
          768: {
            slidesPerView: "auto",
            spaceBetween: 40,
          },
          1280: {
            slidesPerView: "auto",
            spaceBetween: 84,
          },
          1440: {
            slidesPerView: "auto",
            spaceBetween: 96,
          },
        },
      });
      var swiperhonest = new Swiper(".desktop-view .honest-slider", {
        pagination: {
          el: ".honest-pagination.desktop",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        },
        breakpoints: {
          560: {
            slidesPerView: "auto",
            spaceBetween: 48,
          },
          768: {
            slidesPerView: "auto",
            spaceBetween: 40,
          },
          1280: {
            slidesPerView: "auto",
            spaceBetween: 84,
          },
          1440: {
            slidesPerView: "auto",
            spaceBetween: 96,
          },
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("honest-review", HonestReview);

class Custommainsearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".variants-pills").click(function () {
        var sel_var = $(this).attr("data-varimage");
        var sel_url = $(this).attr("data-varurl");
        $(this)
          .parents(".custom_card_product_main")
          .find("a")
          .attr("href", sel_url);
        $(this)
          .parents(".custom_card_product_main")
          .find("modal-opener")
          .attr("data-product-url", sel_url);
        $(this)
          .parents(".custom_card_product_main")
          .find(".quick-add__submit")
          .attr("data-product-url", sel_url);
        $(this)
          .parents(".custom_card_product_main")
          .find(".custom_card_media img")
          .attr("srcset", sel_var);
        $(this)
          .parents(".custom_card_product_main")
          .find(".variants-pills")
          .removeClass("selected");
        $(this).addClass("selected");
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-main-search", Custommainsearch);

class collection_custom_slider extends HTMLElement {
  constructor() {
    super();
    var swiper = new Swiper(".carousel-slider", {
      slidesPerView: 1.2,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".carousel-slider", {
        slidesPerView: 1.2,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("collection-custom-slider", collection_custom_slider);

class collection_grid_slider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var view_count = $(".my-swiper-slider").attr("data_grid");
      var swiper = new Swiper(".my-swiper-slider", {
        slidesPerView: 1.2,
        spaceBetween: 10,
        navigation: {
          nextEl: ".arrow-tabs .right-arrow",
          prevEl: ".arrow-tabs .left-arrow",
        },
        breakpoints: {
          768: {
            slidesPerView: 2.3,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 2.3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: view_count,
            spaceBetween: 20,
          },
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("collection-grid-slider", collection_grid_slider);

class custom_collection_product extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if ($(this).data("showvariant") == true) {
        $(".variants-pills").click(function () {
          var sel_var = $(this).attr("data-varimage");
          var sel_url = $(this).attr("data-varurl");

          $(this)
            .parents(".custom_card_product_main")
            .find(".custom_card_media img")
            .attr("srcset", sel_var);
          $(this)
            .parents(".custom_card_product_main")
            .find(".variants-pills")
            .removeClass("selected");

          $(this).addClass("selected");
        });
        $(".product-card-wrapper").mouseleave(function () {
          var varimage = $(this)
            .find(".custom_product_variant_container")
            .data("variantimg");
          $(".variants-pills").removeClass("selected");
          $(this).find(".custom_card_media img").eq(0).attr("srcset", varimage);
        });
      } else {
        $(".variants-pills").click(function () {
          var sel_var = $(this).attr("data-varimage");
          var sel_url = $(this).attr("data-varurl");
          $(this)
            .parents(".custom_card_product_main")
            .find("a")
            .attr("href", sel_url);
          $(this)
            .parents(".custom_card_product_main")
            .find(".card__media")
            .attr("onclick", 'location.href="' + sel_url + '"');
          $(this)
            .parents(".custom_card_product_main")
            .find("modal-opener")
            .attr("data-product-url", sel_url);
          $(this)
            .parents(".custom_card_product_main")
            .find(".quick-add__submit")
            .attr("data-product-url", sel_url);
          $(this)
            .parents(".custom_card_product_main")
            .find(".custom_card_media img")
            .attr("srcset", sel_var);
          $(this)
            .parents(".custom_card_product_main")
            .find(".variants-pills")
            .removeClass("selected");
          $(this).addClass("selected");
        });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-collection-product", custom_collection_product);

class custom_tab_view extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      const $tabHeaders = $(this).find(".tabheadingview");
      const $tabContents = $(this).find(".contenttabview");

      $tabHeaders.each(function (index) {
        $(this).on("click", function () {
          $tabHeaders.removeClass("active");
          $tabContents.removeClass("active");
          $(this).addClass("active");
          $tabContents.eq(index).addClass("active");
        });
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-tab-view", custom_tab_view);

class BannerSliderGuide extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var swiperguide = new Swiper(".banner-slider-guide", {
        pagination: {
          el: ".swiper-pagination-guide",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next-guide",
          prevEl: ".swiper-button-prev-guide",
        },
        loop: true,
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("banner-slide-guide", BannerSliderGuide);

$(".showmorepill").click(function () {
  $(this).hide();
  $(this).parent().find(".custom_variants_pills").show();
});

class MainBlogTemplate extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var swiper;
      loadSwiper();
      $(".blog-tags-list a").click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        //console.log("rrrrr");
        loadData($(this).attr("href"), $(this).parent().data("index"));
        $(".blog-tags-list a").removeClass("active");
        $(this).addClass("active");
      });

      function loadData(url, index) {
        $("main-blog-template .main-blog").css("text-align", "center");
        $("main-blog-template .main-blog").html(
          '<img style="text-align:center;width:60px;height:60px;margin:10rem auto 5rem;" src="https://cdn.shopify.com/s/files/1/0626/2105/7254/files/loading-gif.gif"/>'
        );
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText;
            var htmlmake = new DOMParser()
              .parseFromString(html, "text/html")
              .getElementsByClassName("main-blog-template")[0].innerHTML;
            $("main-blog-template").html(htmlmake);
            $("main-blog-template").css("text-align", "initial");
            $(".blog-tags-list a").removeClass("active");
            $(".blog-tags-list a").eq(index).addClass("active");
            $(".blog-tags-list a").click(function (e) {
              e.preventDefault();
              e.stopPropagation();
              loadData($(this).attr("href"), $(this).parent().data("index"));
              $(".blog-tags-list a").removeClass("active");
              $(this).addClass("active");
            });
            loadSwiper();
            swiper.slideTo(index);
          });
      }
      function loadSwiper() {
        swiper = new Swiper(".tabs-slider", {
          slidesPerView: "auto",
          spaceBetween: 0,
          css: true,
          freescroll: true,
          pagination: {
            el: ".tabs-pagination",
            type: "progressbar",
          },
        });
      }
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("main-blog-template", MainBlogTemplate);

class Customarticleslider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".slider-quote-main", {
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: ".swiper-pagination-quote",
          clickable: true,
        },
      });

      var swiper = new Swiper(".article-slider", {
        slidesPerView: "auto",
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          560: {
            slidesPerView: "auto",
            spaceBetween: 20,
          },
          768: {
            slidesPerView: "auto",
            spaceBetween: 20,
          },
        },
        pagination: {
          el: ".swiper-pagination-article",
          clickable: true,
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-article-slider", Customarticleslider);

class custombannerslider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".banner-slider", {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("banner-slider", custombannerslider);

class FAQPageSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".faqleftbtn").click(function () {
        var index = $(this).attr("data-index");
        $('.faq-item-container[data-index="' + index + '"]')
          .get(0)
          .scrollIntoView({ behavior: "smooth" });
      });

      $(".faq-title")
        .unbind()
        .click(function () {
          $(".faq-content").hide(100);
          if ($(this).siblings(".faq-content").hasClass("faqactive")) {
            $(this).siblings(".faq-content").removeClass("faqactive");
          } else {
            $(this).siblings(".faq-content").addClass("faqactive");
            $(this).siblings(".faq-content").show(100);
          }
        });

      var init = false;

      function swiperCard() {
        if (window.innerWidth <= 768) {
          if (!init) {
            init = true;
            swiper = new Swiper(".faq-slider", {
              direction: "horizontal",
              slidesPerView: "auto",
              spaceBetween: 40,
            });
          }
        } else if (init) {
          swiper.destroy();
          init = false;
        }
      }
      swiperCard();
      window.addEventListener("resize", swiperCard);
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("faq-page-section", FAQPageSection);

class announcementbar2 extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var time =
        Number($(this).find(".announcement--bar-container").data("timedelay")) *
        100;
      var swiper = new Swiper(".announcement-slider", {
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: time,
          disableOnInteraction: false,
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("announcement-bar", announcementbar2);

class carousel1 extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".carousel", {
        slidesPerView: "auto",
        spaceBetween: 30,
        freeMode: false,
        breakpoints: {
          560: {
            spaceBetween: 48,
            slidesPerView: "auto",
          },
          1024: {
            spaceBetween: 40,
            slidesPerView: "auto",
          },
          1280: {
            spaceBetween: 84,
            slidesPerView: "auto",
          },
          1440: {
            spaceBetween: 96,
            slidesPerView: "auto",
          },
        },
        navigation: {
          nextEl: ".carousel .right-arrow",
          prevEl: ".carousel .left-arrow",
        },
        pagination: {
          el: ".swiper-pagination",
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("carousel-review", carousel1);

class coloricongrid extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".icon-grid", {
        slidesPerView: "auto",
        spaceBetween: 50,
        freeMode: true,
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("color-icon-grid", coloricongrid);

class colorguideblogs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".slider-blogs", {
        slidesPerView: 1.267,
        loop: true,
        spaceBetween: 20,
        autoplay: 2000,
        breakpoints: {
          768: {
            slidesPerView: 1.8,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 1.8,
            spaceBetween: 20,
          },
          1099: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
        },
      });

      $(".slider-blogs").hover(
        function () {
          this.swiper.autoplay.start();
        },
        function () {
          this.swiper.autoplay.stop();
        }
      );

      var swiper = new Swiper(".article-slider-new", {
        slidesPerView: 1.267,
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next-color",
          prevEl: ".swiper-button-prev-color",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("color-guide-blogs", colorguideblogs);

class imageslidercolorlanding extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".grid-slider", {
        slidesPerView: 1.48,
        spaceBetween: 15,
        breakpoints: {
          640: {
            slidesPerView: 1.48,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("image-slider-color-landing", imageslidercolorlanding);

class bannerthread extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".banner-grid", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next-guide",
          prevEl: ".swiper-button-prev-guide",
        },
        pagination: {
          el: ".swiper-pagination-guide",
          clickable: true,
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("banner-thread", bannerthread);

class imagewithcaption extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".image-with-caption-slider", {
        slidesPerView: 1.1,
        spaceBetween: 5,
        breakpoints: {
          640: {
            slidesPerView: 1.1,
            spaceBetween: 10,
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("image-with-caption", imagewithcaption);

class tabcontainercare extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".tablinks").click(function () {
        $(".tablinks").removeClass("underline-bottom");
        $(this).addClass("underline-bottom");
        var name = $(this).data("name");
        $(".block_content").hide();
        $('.block_content[data-name="' + name + '"]').show();
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("tab-container-care", tabcontainercare);

class latestblogguide extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".slider-quote-main", {
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: ".swiper-pagination-quote",
          clickable: true,
        },
      });

      var swiper = new Swiper(".article-slider", {
        slidesPerView: 1.2,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination-article",
          clickable: true,
        },
        navigation: {
          nextEl: ".right-arrow-article",
          prevEl: ".left-arrow-article",
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("latest-blog-guide", latestblogguide);

class loginpage extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(document).ready(function () {
        $(".login_button").click(function () {
          $(this).find(".loading-overlay__spinner").show();
          $(this).find(".loading-overlay__spinner").removeClass("hidden");
          $(this).find(".login-text").hide();
        });
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("login-page", loginpage);

class registerpage extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(document).ready(function () {
        $(".register_button").click(function () {
          $(this).find(".loading-overlay__spinner").show();
          $(this).find(".loading-overlay__spinner").removeClass("hidden");
          $(this).find(".login-text").hide();
        });
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("register-page", registerpage);

class materialsliderthread extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".material--slider-thread", {
        slidesPerView: 1.6,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 33,
          },
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("material-slider-thread", materialsliderthread);

class mediawithcontentfabric extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(document).ready(function () {
        if (window.screen.width < 990) {
          $(".play-button").click(function () {
            $(this)
              .parents(".image-container")
              .find(".mobile-video")
              .get(0)
              .play();
            $(this).data("play", "true");
            $(this).hide();
          });
          $(".pause-button").click(function () {
            $(this)
              .parents(".image-container")
              .find(".mobile-video")
              .get(0)
              .pause();
            $(this).hide();
            $(this).parents(".image-container").find(".play-button").show();
            $(this)
              .parents(".image-container")
              .find(".play-button")
              .data("show");
            $(this)
              .parents(".image-container")
              .find(".play-button")
              .data("play", "false");
          });

          $(".image-container").mousemove(function (event) {
            var play = $(this).find(".play-button").data("play");
            if (play == "true") {
              $(this).find(".pause-button").show();
            }
          });
        } else {
          $(".play-button").click(function () {
            $(this)
              .parents(".image-container")
              .find(".desktop-video")
              .get(0)
              .play();
            $(this).data("play", "true");
            $(this).hide();
          });
          $(".pause-button").click(function () {
            $(this)
              .parents(".image-container")
              .find(".desktop-video")
              .get(0)
              .pause();
            $(this).hide();
            $(this).parents(".image-container").find(".play-button").show();
            $(this)
              .parents(".image-container")
              .find(".play-button")
              .data("show");
            $(this)
              .parents(".image-container")
              .find(".play-button")
              .data("play", "false");
          });
          $(".image-container").mousemove(function (event) {
            var play = $(this).find(".play-button").data("play");
            if (play == "true") {
              $(this).find(".pause-button").show();
            }
          });
        }
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("media-with-content-fabric", mediawithcontentfabric);

class bathimagewithcontent2 extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".bath-play-2-button").click(function () {
        $(this)
          .parents(".bath-image-with-content-2-container")
          .find("video")
          .trigger("play");
        $(this)
          .parents(".bath-image-with-content-2-container")
          .find("video")
          .addClass("playing");
        $(this).hide();
      });

      $("video")
        .parent()
        .mouseenter(function () {
          if (
            $(this).find(".bath-pause-2-button").length &&
            $(this).find("video").hasClass("playing")
          ) {
            $(this).find(".bath-pause-2-button").show();
          }
        })
        .mouseleave(function () {
          if ($(this).find(".bath-pause-2-button").length) {
            $(this).find(".bath-pause-2-button").hide();
          }
        });

      $(".bath-pause-2-button").click(function () {
        $(this)
          .parents(".bath-image-with-content-2-container")
          .find("video")
          .trigger("pause");
        $(this)
          .parents(".bath-image-with-content-2-container")
          .find("video")
          .removeClass("playing");
        $(this).hide();
        $(this).parent().find(".bath-play-2-button").show();
      });
      $("video").click(function () {
        if ($(this).hasClass("playing")) {
          $(this)
            .parents(".bath-image-with-content-2-container")
            .find("video")
            .trigger("pause");
          $(this)
            .parents(".bath-image-with-content-2-container")
            .find("video")
            .removeClass("playing");
          $(this).parent().find(".bath-pause-2-button").hide();
          $(this).parent().find(".bath-play-2-button").show();
        }
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("bath-image-with-content-2", bathimagewithcontent2);

class bathimagewithcontent3 extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".bath-play-3-button").click(function () {
        $(this)
          .parents(".bath-image-with-content-3-container")
          .find("video")
          .trigger("play");
        $(this)
          .parents(".bath-image-with-content-3-container")
          .find("video")
          .addClass("playing");
        $(this).hide();
      });

      $("video")
        .parent()
        .mouseenter(function () {
          if (
            $(this).find(".bath-pause-3-button").length &&
            $(this).find("video").hasClass("playing")
          ) {
            $(this).find(".bath-pause-3-button").show();
          }
        })
        .mouseleave(function () {
          if ($(this).find(".bath-pause-3-button").length) {
            $(this).find(".bath-pause-3-button").hide();
          }
        });

      $(".bath-pause-3-button").click(function () {
        $(this)
          .parents(".bath-image-with-content-3-container")
          .find("video")
          .trigger("pause");
        $(this)
          .parents(".bath-image-with-content-3-container")
          .find("video")
          .removeClass("playing");
        $(this).hide();
        $(this).parent().find(".bath-play-3-button").show();
      });
      $("video").click(function () {
        if ($(this).hasClass("playing")) {
          $(this)
            .parents(".bath-image-with-content-3-container")
            .find("video")
            .trigger("pause");
          $(this)
            .parents(".bath-image-with-content-3-container")
            .find("video")
            .removeClass("playing");
          $(this).parent().find(".bath-pause-3-button").hide();
          $(this).parent().find(".bath-play-3-button").show();
        }
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("bath-image-with-content-3", bathimagewithcontent3);

class bathimagewithcontent1 extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".play-1-button").click(function () {
        $(this)
          .parents(".image-with-content-1-container")
          .find("video")
          .trigger("play");
        $(this)
          .parents(".image-with-content-1-container")
          .find("video")
          .addClass("playing");
        $(this).hide();
      });

      $("video")
        .parent()
        .mouseenter(function () {
          if (
            $(this).find(".pause-1-button").length &&
            $(this).find("video").hasClass("playing")
          ) {
            $(this).find(".pause-1-button").show();
          }
        })
        .mouseleave(function () {
          if ($(this).find(".pause-1-button").length) {
            $(this).find(".pause-1-button").hide();
          }
        });

      $(".pause-1-button").click(function () {
        $(this)
          .parents(".image-with-content-1-container")
          .find("video")
          .trigger("pause");
        $(this)
          .parents(".image-with-content-1-container")
          .find("video")
          .removeClass("playing");
        $(this).hide();
        $(this).parent().find(".play-1-button").show();
      });
      $("video").click(function () {
        if ($(this).hasClass("playing")) {
          $(this)
            .parents(".image-with-content-1-container")
            .find("video")
            .trigger("pause");
          $(this)
            .parents(".image-with-content-1-container")
            .find("video")
            .removeClass("playing");
          $(this).parent().find(".pause-1-button").hide();
          $(this).parent().find(".play-1-button").show();
        }
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("bath-image-with-content-1", bathimagewithcontent1);

class rangewithcolor extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".range-grid-slider", {
        slidesPerView: 1.662,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".arrows .right-arrow",
          prevEl: ".arrows .left-arrow",
        },
        breakpoints: {
          640: {
            slidesPerView: 1.662,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("range-with-color", rangewithcolor);

class mainvideo extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(document).ready(function () {
        if (document.body.offsetWidth < 990) {
          $(".play-button").click(function () {
            $(this)
              .parents(".custom-video-container")
              .find(".mobile-video")
              .get(0)
              .play();
            $(this)
              .parents(".custom-video-container")
              .find(".mobile-video")
              .show();
            $(this).data("play", "true");
            $(this).hide();
          });
          $(".pause-button").click(function () {
            $(this)
              .parents(".custom-video-container")
              .find(".mobile-video")
              .get(0)
              .pause();
            $(this).hide();
            $(this)
              .parents(".custom-video-container")
              .find(".play-button")
              .show();
            $(this)
              .parents(".custom-video-container")
              .find(".play-button")
              .data("show");
            $(this)
              .parents(".custom-video-container")
              .find(".play-button")
              .data("play", "false");
          });

          $(".custom-video-container").mousemove(function (event) {
            var play = $(this).find(".play-button").data("play");
            if (play == "true") {
              $(this).find(".pause-button").show();
            }
          });
        } else {
          $(".play-button").click(function () {
            $(this)
              .parents(".custom-video-container")
              .find(".desktop-video")
              .get(0)
              .play();

            $(this).data("play", "true");
            $(this).hide();
          });
          $(".pause-button").click(function () {
            $(this)
              .parents(".custom-video-container")
              .find(".desktop-video")
              .get(0)
              .pause();
            $(this).hide();
            $(this)
              .parents(".custom-video-container")
              .find(".play-button")
              .show();
            $(this)
              .parents(".custom-video-container")
              .find(".play-button")
              .data("show");
            $(this)
              .parents(".custom-video-container")
              .find(".desktop-video")
              .hide();
            $(this)
              .parents(".custom-video-container")
              .find(".play-button")
              .data("play", "false");
          });

          $(".custom-video-container").mousemove(function (event) {
            var play = $(this).find(".play-button").data("play");
            if (play == "true") {
              $(this).find(".pause-button").show();
            }
          });
        }
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("main-video", mainvideo);

class faqshipping extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      jQuery(document).ready(function () {
        $(".faqques")
          .eq($(".faqques").length - 1)
          .css("border-bottom", "1px solid #f1f1f1");
        $(".faqques").eq(0).find(".answer").show(100);
        $(".question")
          .unbind()
          .click(function () {
            // console.log("dsdsds");
            $(this).parent().find(".answer").toggle(100);
          });
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("faq-shipping", faqshipping);

class ArticlePrdocut extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".custom_variants_pills").click(function () {
        var sel_var = $(this).attr("data-varimage");
        // console.log("selvar==" + sel_var);

        $(this)
          .parents(".custom_grid_product_item")
          .find(".custom_card_media img")
          .attr("srcset", sel_var);

        $(this)
          .parents(".custom_grid_product_item")
          .find(".custom_variants_pills")
          .removeClass("selected");
        $(this).addClass("selected");
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("article--product", ArticlePrdocut);

class RecentlyViewed extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".custom_variants_pills").click(function () {
        var sel_var = $(this).attr("data-varimage");
        //console.log("selvar==" + sel_var);

        $(this)
          .parents(".custom_grid_product_item")
          .find(".custom_card_media img")
          .attr("srcset", sel_var);

        $(this)
          .parents(".custom_grid_product_item")
          .find(".custom_variants_pills")
          .removeClass("selected");
        $(this).addClass("selected");
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("recently-viewed", RecentlyViewed);

if (document.addEventListener) {
  document.addEventListener("fullscreenchange", exitHandler, false);
  document.addEventListener("mozfullscreenchange", exitHandler, false);
  document.addEventListener("MSFullscreenChange", exitHandler, false);
  document.addEventListener("webkitfullscreenchange", exitHandler, false);
}

function exitHandler() {
  if (
    !document.isFullScreen &&
    !document.webkitIsFullScreen &&
    !document.mozFullScreen &&
    !document.msFullscreenElement
  ) {
    $(".full-screen")
      .parents(".custom-video-container")
      .find("video")
      .removeClass("full-view");
    $(".full-screen")
      .parents(".image-container")
      .find("video")
      .removeClass("full-view");
  }
}

$(document).ready(function () {
  $(".full-screen").click(function () {
    if (window.screen.width < 990) {
      var videoElement = $(this).parent().find(".mobile-video")[0];
      if (videoElement.requestFullscreen) {
        $(this)
          .parents(".custom-video-container")
          .find("video")
          .addClass("full-view");
        $(this).parents(".image-container").find("video").addClass("full-view");
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) {
        $(this)
          .parents(".custom-video-container")
          .find("video")
          .addClass("full-view");
        $(this).parents(".image-container").find("video").addClass("full-view");
        videoElement.mozRequestFullScreen(); // Firefox
      } else if (videoElement.webkitRequestFullscreen) {
        $(this)
          .parents(".custom-video-container")
          .find("video")
          .addClass("full-view");
        $(this).parents(".image-container").find("video").addClass("full-view");
        videoElement.webkitRequestFullscreen(); // Chrome, Safari & Opera
      } else if (videoElement.msRequestFullscreen) {
        $(this)
          .parents(".custom-video-container")
          .find("video")
          .addClass("full-view");
        $(this).parents(".image-container").find("video").addClass("full-view");
        videoElement.msRequestFullscreen(); // IE/Edge
      } else {
        videoElement.webkitEnterFullscreen();
        videoElement.enterFullscreen();
      }
    } else {
      var videoElement = $(this).parent().find(".desktop-video")[0];
      if (videoElement.requestFullscreen) {
        $(this)
          .parents(".custom-video-container")
          .find("video")
          .addClass("full-view");
        $(this).parents(".image-container").find("video").addClass("full-view");
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) {
        $(this)
          .parents(".custom-video-container")
          .find("video")
          .addClass("full-view");
        $(this).parents(".image-container").find("video").addClass("full-view");
        videoElement.mozRequestFullScreen(); // Firefox
      } else if (videoElement.webkitRequestFullscreen) {
        $(this)
          .parents(".custom-video-container")
          .find("video")
          .addClass("full-view");
        $(this).parents(".image-container").find("video").addClass("full-view");
        videoElement.webkitRequestFullscreen(); // Chrome, Safari & Opera
      } else if (videoElement.msRequestFullscreen) {
        $(this)
          .parents(".custom-video-container")
          .find("video")
          .addClass("full-view");
        $(this).parents(".image-container").find("video").addClass("full-view");
        videoElement.msRequestFullscreen(); // IE/Edge
      }
    }
  });
});
if (performance.navigation.type == 2) {
  location.reload(true);
}

class VariantPickerBundle extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var this2 = this;

      $(this2)
        .parents(".custom_main_product_grid_bundle")
        .find(".product-form__submit")
        .removeAttr("disabled");
      $(this2)
        .parents(".custom_main_product_grid_bundle")
        .find(".product-form__submit span")
        .html("Add to cart");
      $(this2)
        .parents(".custom_main_product_grid_bundle")
        .find(".allvars")
        .each(function () {
          var val = $(this).find(":selected").data("available");
          //console.log(val + " dsdsdsd");
          if (val == false) {
            $(this2)
              .parents(".custom_main_product_grid_bundle")
              .find(".product-form__submit")
              .attr("disabled", "disabled");
            $(this2)
              .parents(".custom_main_product_grid_bundle")
              .find(".product-form__submit span")
              .html("Sold Out");
          }
        });

      $(this2)
        .parents(".custom_main_product_grid_bundle")
        .find(".variantradiocustom input")
        .on("change", function () {
          var thisto = $(this);
          var selestr = "";
          $(this).parents("fieldset").find(".error-msg").remove();
          if ($(this).parents("fieldset").hasClass("variantcolorcustom")) {
            var sel_var = $(this).attr("data-varimage");
            //console.log("selvar==" + sel_var);

            $(this)
              .parents(".bundle-block-content")
              .find(".bunderpr-image img")
              .attr("src", sel_var);
            $(this)
              .parents(".bundle-block-content")
              .find(".color-name")
              .html($(this).val());
          }

          $(this)
            .parents(".variantradiocustom")
            .find("fieldset")
            .each(function () {
              var val = $(this).find('input[type="radio"]:checked').val();
              selestr = selestr + "," + val;
            });
          selestr = selestr.substring(1);
          $(this)
            .parents(".variantradiocustom")
            .find(".allvars option")
            .each(function () {
              var splitsel = selestr.split(",");
              var title = $(this).data("title");
              var avaialable = $(this).data("available");
              if (thisto.parents("fieldset").hasClass("variantcolorcustom")) {
                $(this)
                  .parents(".bundle-block-content")
                  .find(".variantsizecustom input")
                  .each(function () {
                    var carr = title.split("/").map(function (item) {
                      return item.trim();
                    });
                    if (
                      carr.indexOf(thisto.val()) != -1 &&
                      carr.indexOf($(this).val()) != -1
                    ) {
                      if (avaialable == false) {
                        $(this).addClass("disabled");
                      } else {
                        $(this).removeClass("disabled");
                      }
                    }
                  });
              }
              if (thisto.parents("fieldset").hasClass("variantsizecustom")) {
                $(this)
                  .parents(".bundle-block-content")
                  .find(".variantcolorcustom input")
                  .each(function () {
                    var carr = title.split("/").map(function (item) {
                      return item.trim();
                    });
                    if (
                      carr.indexOf(thisto.val()) != -1 &&
                      carr.indexOf($(this).val()) != -1
                    ) {
                      //console.log('tsttt working '+avaialable)
                      if (avaialable == false) {
                        $(this).addClass("disabled");
                      } else {
                        $(this).removeClass("disabled");
                      }
                    }
                  });
              }
              var carr = title.split("/").map(function (item) {
                return item.trim();
              });
              if (splitsel.length == 1) {
                if (carr.indexOf(splitsel[0]) != -1) {
                  $(this)
                    .parents(".variantradiocustom")
                    .find(".allvars")
                    .val($(this).attr("value"));
                }
              } else if (splitsel.length == 2) {
                if (
                  carr.indexOf(splitsel[0]) != -1 &&
                  carr.indexOf(splitsel[1]) != -1
                ) {
                  $(this)
                    .parents(".variantradiocustom")
                    .find(".allvars")
                    .val($(this).attr("value"));
                }
              } else {
                if (
                  carr.indexOf(splitsel[0]) != -1 &&
                  carr.indexOf(splitsel[1]) != -1 &&
                  carr.indexOf(splitsel[2]) != -1
                ) {
                  $(this)
                    .parents(".variantradiocustom")
                    .find(".allvars")
                    .val($(this).attr("value"));
                }
              }
            });

          $(this2)
            .parents(".custom_main_product_grid_bundle")
            .find(".product-form__submit")
            .removeAttr("disabled");
          $(this2)
            .parents(".custom_main_product_grid_bundle")
            .find(".product-form__submit span")
            .html("Add to cart");
          $(this2)
            .parents(".custom_main_product_grid_bundle")
            .find(".allvars")
            .each(function () {
              var val = $(this).find(":selected").data("available");

              if (val == false) {
                $(this2)
                  .parents(".custom_main_product_grid_bundle")
                  .find(".product-form__submit")
                  .attr("disabled", "disabled");
                $(this2)
                  .parents(".custom_main_product_grid_bundle")
                  .find(".product-form__submit span")
                  .html("Sold Out");
              }
            });

          checkAllCheck();
        });
      checkAllCheck();
      function checkAllCheck() {
        var allcheck = true;
        $(this2)
          .parents(".custom_main_product_grid_bundle")
          .find(".main_bundle_block")
          .each(function () {
            var cchecked = true;
            if ($(this).find(".variantsizecustom").length != 0) {
              if (
                $(this)
                  .find(".variantsizecustom")
                  .find("input[type=radio]:checked").length == 0
              ) {
                allcheck = false;
                cchecked = false;
              }
            }
            if ($(this).find(".variantcolorcustom").length != 0) {
              if (
                $(this)
                  .find(".variantcolorcustom")
                  .find("input[type=radio]:checked").length == 0
              ) {
                allcheck = false;
                cchecked = false;
              }
            }
            if (cchecked == true) {
              $(this).find(".variant_picker_bundle_main").addClass("active");
            }
          });
        if (allcheck == true) {
          var totalprice = 0;
          $(this2)
            .parents(".custom_main_product_grid_bundle")
            .find(".allvars")
            .each(function () {
              var val = $(this).find(":selected").data("price");
              // console.log(val + " pppp");
              totalprice = totalprice + Number(val);
            });
          console.log(totalprice);
          var curtotalprice = totalprice * Shopify.currency.rate;
          console.log("slecur" + totalprice);
          var discount = $(this2)
            .parents(".custom_main_product_grid_bundle")
            .find(".main_bundle_block")
            .data("discount");
          var discountprice = (discount * totalprice) / 100;
          var cprice = totalprice - discountprice;
          var curdiscountprice = (discount * curtotalprice) / 100;
          $(this2)
            .parents(".custom_main_product_grid_bundle")
            .find(".bundle_total")
            .attr("data-bundleprice", (cprice / 100).toFixed(2) + "");
          $(this2)
            .parents(".custom_main_product_grid_bundle")
            .find(".bundle_total")
            .attr("data-totalprice", (totalprice / 100).toFixed(2) + "");
          //console.log($(this2).parents('.custom_main_product_grid_bundle').find('.bundle_total').html());

          var discountpricefree = $(this2)
            .parents(".custom_main_product_grid_bundle")
            .data("discountprice");

          var symbol = $("body").data("currency");

          if (discountpricefree == 0) {
            $(this2)
              .parents(".custom_main_product_grid_bundle")
              .find(".bundle_total")
              .html(
                Shopify.formatMoney(
                  curtotalprice - curdiscountprice,
                  symbol + "{{amount}}"
                )
              );
          } else {
            $(this2)
              .parents(".custom_main_product_grid_bundle")
              .find(".bundle_total")
              .html(
                Shopify.formatMoney(
                  curtotalprice - curdiscountprice,
                  symbol + "{{amount}}"
                ) +
                  " (" +
                  Shopify.formatMoney(curtotalprice, symbol + "{{amount}}") +
                  ")"
              );
          }
        }
      }

      if (
        jQuery(".main_bundle_block .variant_picker_bundle_main").hasClass(
          "opened"
        )
      ) {
        jQuery(".main_bundle_block .variant_picker_bundle_main.active")
          .closest(".main_bundle_block")
          .find(".bundle-block-content")
          .show();
      }
      jQuery(".main_bundle_block .variant_picker_bundle_main").click(
        function () {
          if (jQuery(this).hasClass("opened")) {
            jQuery(this)
              .removeClass("opened")
              .closest(".main_bundle_block")
              .find(".bundle-block-content")
              .slideUp(200);
          } else {
            jQuery(this)
              .addClass("opened")
              .closest(".main_bundle_block")
              .find(".bundle-block-content")
              .slideDown(200);
          }
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("variant-picker-bundle", VariantPickerBundle);

// $(document).ready(function () {
//   var referringUrl = document.referrer;
//   var collectionName = getCollectionNameFromUrl(referringUrl);
//   //console.log("collectionName=="+collectionName);

//   if (collectionName) {
//     collectionName = collectionName.replace(/-/g, " ");
//     var collectionLink =
//       '<a href="' +
//       referringUrl +
//       '" class="breadcrumb-collection body_1 mobile_body_6" style="opacity:1;text-transform: capitalize;">' +
//       collectionName +
//       "</a>";
//     $(".breadcrumb a:last-child").after(
//       '<span aria-hidden="true" style="margin:0px 4px;font-weight:600;opacity:1;" class="body_1 mobile_body_6">></span>' +
//         collectionLink
//     );
//   }
// });

function getCollectionNameFromUrl(url) {
  var matches = url.match(/collections\/([^\/]+)/);
  if (matches && matches.length > 1) {
    return decodeURIComponent(matches[1]);
  }
  return null;
}

class sizeguide extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".fit_guide_slider", {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: ".fit-guide-next",
          prevEl: ".fit-guide-prev",
        },
        pagination: {
          el: ".fit-guide-pagination",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 0,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        },
      });

      var first_block = $(
        ".size_guide_navigation_item[unique_id][unique_id!='']"
      )
        .eq(0)
        .attr("unique_id");
      $(".size_guide_navigation_item[unique_id][unique_id!='']")
        .eq(0)
        .addClass("active");
      $(".size_guide")
        .find(".guide[block_id='" + first_block + "']")
        .css("display", "block");

      $(".size_guide_navigation_item[unique_id][unique_id!='']").click(
        function (event) {
          $(".size_guide_navigation_item").removeClass("active");
          $(".guide").css("display", "none");
          var href = $(this).attr("unique_id");
          var $img = $(this)
            .parents(".size_guide")
            .find(".guide[block_id='" + href + "']")
            .css("display", "block");
          $(this).addClass("active");
        }
      );

      $(".guide")
        .find(".converter-item[converter='cm']")
        .click(function () {
          $(this).parents(".guide").find(".row_inch").css("display", "none");
          $(this).parents(".guide").find(".row_c_m").css("display", "block");
          $(this)
            .parent(".size_guide_converter")
            .find(".converter-item")
            .removeClass("active");
          $(this).addClass("active");
        });

      $(".guide")
        .find(".converter-item[converter='inch']")
        .click(function () {
          $(this).parents(".guide").find(".row_inch").css("display", "block");
          $(this).parents(".guide").find(".row_c_m").css("display", "none");
          $(this)
            .parent(".size_guide_converter")
            .find(".converter-item")
            .removeClass("active");
          $(this).addClass("active");
        });

      $(".guide")
        .find(".converter-item[converter='women']")
        .click(function () {
          $(this).parents(".guide").find(".women").css("display", "block");
          $(this).parents(".guide").find(".men").css("display", "none");
          $(this)
            .parent(".size_guide_converter")
            .find(".converter-item")
            .removeClass("active");
          $(this).addClass("active");
        });

      $(".guide")
        .find(".converter-item[converter='men']")
        .click(function () {
          $(this).parents(".guide").find(".men").css("display", "block");
          $(this).parents(".guide").find(".women").css("display", "none");
          $(this)
            .parent(".size_guide_converter")
            .find(".converter-item")
            .removeClass("active");
          $(this).addClass("active");
        });

      var swiper = new Swiper(".size-nav-items-slide", {
        slidesPerView: "auto",
        freeMode: true,
        spaceBetween: 0,
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("size-guide", sizeguide);

class sizeguideproduct extends HTMLElement {
  constructor() {
    super();
    $(".product-popup-modal-size").html($(this).html());

    var swiper = new Swiper(".fit_guide_slider", {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: ".fit-guide-next",
        prevEl: ".fit-guide-prev",
      },
      pagination: {
        el: ".fit-guide-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });

    var first_block = $(".size_guide_navigation_item[unique_id][unique_id!='']")
      .eq(0)
      .attr("unique_id");
    $(".size_guide_navigation_item[unique_id][unique_id!='']")
      .eq(0)
      .addClass("active");
    $('.guide[block_id="Size Guide"]').css("display", "block");
    console.log(first_block);

    $(".size_guide_navigation_item[unique_id][unique_id!='']").click(function (
      event
    ) {
      $(".size_guide_navigation_item").removeClass("active");
      $(".guide").css("display", "none");
      var href = $(this).attr("unique_id");
      console.log(href);
      $(".guide[block_id='" + href + "']").css("display", "block");
      $(this).addClass("active");
    });

    $(".guide")
      .find(".converter-item[converter='cm']")
      .click(function () {
        $(this).parents(".guide").find(".row_inch").css("display", "none");
        $(this).parents(".guide").find(".row_c_m").css("display", "block");
        $(this)
          .parent(".size_guide_converter")
          .find(".converter-item")
          .removeClass("active");
        $(this).addClass("active");
      });

    $(".guide")
      .find(".converter-item[converter='inch']")
      .click(function () {
        $(this).parents(".guide").find(".row_inch").css("display", "block");
        $(this).parents(".guide").find(".row_c_m").css("display", "none");
        $(this)
          .parent(".size_guide_converter")
          .find(".converter-item")
          .removeClass("active");
        $(this).addClass("active");
      });

    $(".guide")
      .find(".converter-item[converter='women']")
      .click(function () {
        $(this).parents(".guide").find(".women").css("display", "block");
        $(this).parents(".guide").find(".men").css("display", "none");
        $(this)
          .parent(".size_guide_converter")
          .find(".converter-item")
          .removeClass("active");
        $(this).addClass("active");
      });

    $(".guide")
      .find(".converter-item[converter='men']")
      .click(function () {
        $(this).parents(".guide").find(".men").css("display", "block");
        $(this).parents(".guide").find(".women").css("display", "none");
        $(this)
          .parent(".size_guide_converter")
          .find(".converter-item")
          .removeClass("active");
        $(this).addClass("active");
      });

    var swipernav = new Swiper(".size-nav-items-slide", {
      slidesPerView: 3.4,
      freeMode: true,
      spaceBetween: 10,
      breakpoints: {
        768: {
          slidesPerView: 3.4,
          spaceBetween: 10,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 0,
        },
      },
    });
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("size-guide-product", sizeguideproduct);

$(document).ready(function () {
  var symbol = $("body").data("currency");
  $(".bundelprice").each(function () {
    var price = Number($(this).html());
    var cprice = price * Shopify.currency.rate;
    $(this).html(Shopify.formatMoney(cprice, symbol + "{{amount}}"));
  });
  $(".cartbundleitem").each(function () {
    // if ($(this).data("currency") != Shopify.currency.active) {
    var price = Number($(this).data("totalprice"));
    var cprice = price * Shopify.currency.rate * 100;
    $(this).html(Shopify.formatMoney(cprice, symbol + "{{amount}}"));
    // }
  });
  $(".bundleitemdiscount").each(function () {
    // if ($(this).data("currency") != Shopify.currency.active) {
    var price = Number($(this).data("discount"));
    var cprice = price * Shopify.currency.rate * 100;
    $(this).html(Shopify.formatMoney(cprice, symbol + "{{amount}}"));
    // }
  });
  $(".totalsaving").each(function () {
    // if ($(this).data("currency") != Shopify.currency.active) {
    var price =
      Number($(this).data("mainsaving")) +
      Number($(this).data("bundlesaving")) * Shopify.currency.rate;

    $(this).html(Shopify.formatMoney(price, symbol + "{{amount}}"));
    // }
  });
});

// $.ajax({
//   type: "POST",
//   url: "/cart.js",
//   dataType: "json",
//   success: function (cart) {
//     for (let index = 0; index < cart.items.length; index++) {
//       console.log(cart.items[index].properties["_bundle"]);
//       if (cart.items[index].properties["_bundle"] == "true") {
//         if (
//           cart.items[index].properties["_currency"] != Shopify.currency.active
//         ) {
//           var prop = cart.items[index].properties;
//           prop["_currency"] = Shopify.currency.active;
//           var price = cart.items[index].final_line_price / 100;
//           var cdis = parseFloat(prop["_bundle_price"]) * 100;
//           console.log(parseFloat(prop["_bundle_total"]));
//           cdis = cdis / parseFloat(prop["_bundle_total"]);
//           var discount = Number(cdis);
//           console.log(discount);
//           console.log(cdis);
//           var cprice = (price * 100) / discount;
//           prop["_bundle_price"] = price.toFixed(2) + "";
//           prop["_bundle_total"] = cprice.toFixed(2) + "";
//           var jbody = {};
//           jbody["id"] = cart.items[index].key;
//           jbody["properties"] = prop;
//           console.log(jbody);
//           fetch("/cart/change.js", {
//             method: "POST",
//             body: JSON.stringify(jbody),
//             headers: {
//               "Content-Type": "application/json",
//             },
//           })
//             .then((response) => response.json())
//             .then((data) => {})
//             .catch((error) => {
//               // Handle errors here
//             });
//           // $.ajax({
//           //   url: "/cart/change.js",
//           //   type: "POST",
//           //   dataType: 'json',
//           //   data: jbody,
//           //   dataType: "json",
//           //   success: function (cart) {
//           //     //window.location.reload();
//           //   },
//           // });
//         }
//       }
//     }
//   },
//   error: function (err) {},
// });

class mediaslider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".slider-quote-main", {
        slidesPerView: 1,
        spaceBetween: 60,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: ".swiper-pagination-quote",
          clickable: true,
        },
      });

      var swiper = new Swiper(".article-slider", {
        slidesPerView: "auto",
        spaceBetween: 60,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          560: {
            slidesPerView: "auto",
            spaceBetween: 60,
          },
          768: {
            slidesPerView: "auto",
            spaceBetween: 60,
          },
        },
        pagination: {
          el: ".swiper-pagination-article",
          clickable: true,
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("media-slider", mediaslider);

class faqsustainable extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      jQuery(document).ready(function () {
        // $(".faq")
        //   .eq($(".faq").length - 1)
        //   .css("border-bottom", "1px solid #f1f1f1");
        $(".faq").eq(0).find(".rich-text__text").show(100);
        $(".rich-text__subheading")
          .unbind()
          .click(function () {
            $(this).parent().find(".rich-text__text").toggle(100);
          });
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("faq-sustainable", faqsustainable);

class CustomImageSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({"opacity":"1"});
      var speed = $(this).data('speed');

      var swiper = new Swiper(".slide-image-" + this.getAttribute("data-sectionid"), {
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        effect: 'linear',
        spaceBetween: 40,
        slidesPerView: 1.8,
        loop: true,
        speed: speed,
        breakpoints: {
          640: {
            slidesPerView:1.8,
            spaceBetween: 40,
            loop: true,
          },
          768: {
            slidesPerView:3.2,
            spaceBetween: 60,
            loop: true,
          },
          1024: {
            slidesPerView:3.8,
            spaceBetween: 80,
            loop: true,
          },
          1441: {
            slidesPerView:4.8,
            spaceBetween: 80,
            loop: true,
          },
        },
      }); 
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-image-slider", CustomImageSlider);
